"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8107],{

/***/ 75150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ cssVars; }
/* harmony export */ });
var cssVars = {
    topBarHeight: createCssVarHandlers("--top-bar-height")
};
function getRoot() {
    return document.documentElement;
}
function createCssVarHandlers(variableName) {
    return {
        name: variableName,
        getValue: function getValue() {
            return getComputedStyle(getRoot()).getPropertyValue(variableName);
        },
        setValue: function setValue(value) {
            return getRoot().style.setProperty(variableName, value);
        }
    };
}


/***/ }),

/***/ 26540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FL": function() { return /* binding */ createOpportunity; },
/* harmony export */   "FS": function() { return /* binding */ createQfLeadMutation; },
/* harmony export */   "So": function() { return /* binding */ authenticateUser; },
/* harmony export */   "wN": function() { return /* binding */ funnelCheckoutMutation; }
/* harmony export */ });
/* unused harmony exports CREATE_OPPORTUNITY, AUTHENTICATE_USER, FUNNEL_CHECKOUT, CREATE_QF_LEAD */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26997);
/* harmony import */ var shared_services_opportunityCreationPayload__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45417);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation($attributes: OpportunityAttributes!) {\n    createOpportunity(attributes: $attributes) {\n      success\n      opportunity {\n        id\n        userId\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation AuthenticateUser($email: String!, $password: String!) {\n    authenticateUser(credentials: { email: $email, password: $password }) {\n      authToken\n      userAccount {\n        id\n        email\n        firstName\n        lastName\n        roles\n        owner {\n          ... on Customer {\n            id\n            companyName\n            deliveryAddressStreetAndNumber\n            deliveryAddressPostalCode\n            deliveryAddressCity\n            deliveryAddressCountry\n            salesforceCustomer {\n              billingAddress {\n                street\n                postalCode\n                city\n                country\n              }\n              phoneNumber\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation funnelCheckout($attributes: FunnelCheckoutAttributes!) {\n    funnelCheckout(attributes: $attributes) {\n      opportunity {\n        id\n        userId\n      }\n      customerAccount {\n        uuid\n      }\n      success\n      signInToken\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation createQfLead($attributes: QfLeadAttributes!) {\n    createQfLead(attributes: $attributes) {\n      success\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var CREATE_OPPORTUNITY = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject());
function createOpportunity(payload, _) {
    return _createOpportunity.apply(this, arguments);
}
function _createOpportunity() {
    _createOpportunity = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(payload, param) {
        var client, attributes, ref, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    client = param.client;
                    attributes = (0,shared_services_opportunityCreationPayload__WEBPACK_IMPORTED_MODULE_1__/* .createOpportunityCreationPayload */ .D)(payload);
                    return [
                        4,
                        client.mutation(CREATE_OPPORTUNITY, {
                            attributes: attributes
                        }).toPromise()
                    ];
                case 1:
                    ref = _state.sent(), result = ref.data;
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return _createOpportunity.apply(this, arguments);
}
var AUTHENTICATE_USER = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject1());
var authenticateUser = function(email, password, param) {
    var client = param.client;
    return client.mutation(AUTHENTICATE_USER, {
        email: email,
        password: password
    }).toPromise();
};
var FUNNEL_CHECKOUT = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject2());
var CREATE_QF_LEAD = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject3());
var createQfLeadMutation = function(attributes, param) {
    var client = param.client;
    return client.mutation(CREATE_QF_LEAD, {
        attributes: attributes
    }).toPromise();
};
var funnelCheckoutMutation = function(attributes, param) {
    var client = param.client;
    return client.mutation(FUNNEL_CHECKOUT, {
        attributes: attributes
    }).toPromise();
};


/***/ }),

/***/ 33448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7258);

if (true) {
    yup__WEBPACK_IMPORTED_MODULE_0__.setLocale({
        mixed: {
            required: "common:validations.required"
        },
        string: {
            email: "common:validations.email"
        },
        array: {
            min: function() {
                return "common:validations.required";
            }
        }
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (yup__WEBPACK_IMPORTED_MODULE_0__);


/***/ }),

/***/ 19916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useBreakpointUp; },
/* harmony export */   "a": function() { return /* binding */ useBreakpointDown; }
/* harmony export */ });
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63457);

var useBreakpointDown = function(breakpoint) {
    var isUnderBreakpoint = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.down(breakpoint);
    });
    return isUnderBreakpoint;
};
var useBreakpointUp = function(breakpoint) {
    var isOverBreakpoint = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.up(breakpoint);
    });
    return isOverBreakpoint;
};


/***/ }),

/***/ 866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useCurrentUser; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/urql/dist/urql.es.js
var urql_es = __webpack_require__(92432);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@urql/core/dist/urql-core.mjs
var urql_core = __webpack_require__(26997);
;// CONCATENATED MODULE: ./src/lib/graphql/queries.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query currentUserAccount {\n    currentUserAccount {\n      uuid\n      email\n      firstName\n      lastName\n      phone\n      roles\n      owner {\n        ... on CustomerAccount {\n          id\n          companyName\n          admStage\n          deliveryAddressStreetAndNumber\n          deliveryAddressPostalCode\n          deliveryAddressCity\n          deliveryAddressCountry\n          heykantineEnabled\n          salesforceCustomer {\n            isManagedAccount\n            billingAddress {\n              street\n              postalCode\n              city\n              country\n            }\n            phoneNumber\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var GET_CURRENT_USER_ACCOUNT = (0,urql_core/* gql */.Ps)(_templateObject());
var GET_SALESFORCE_ACCOUNT_FROM_CUSTOMER_ACCOUNT = "\n  query customerAccountSalesforceAccountId($uuid: ID!) {\n    customerAccountSalesforceAccountId(uuid: $uuid)\n  }\n";
var GET_CUSTOMER_CONTACT_ID_FROM_OPPORTUNITY = "\n  query opportunityCustomerContactId($opportunityId: ID!) {\n    opportunityCustomerContactId(opportunityId: $opportunityId)\n  }\n";

;// CONCATENATED MODULE: ./src/qualification/hooks/useCurrentUser.ts



function useCurrentUser() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,urql_es/* useQuery */.aM)({
        query: GET_CURRENT_USER_ACCOUNT,
        requestPolicy: "cache-and-network"
    }), 2), ref1 = ref[0], data = ref1.data, fetching = ref1.fetching, reexecuteQuery = ref[1];
    return {
        currentUserAccount: (data === null || data === void 0 ? void 0 : data.currentUserAccount) || null,
        loading: fetching,
        refetch: reexecuteQuery
    };
}


/***/ }),

/***/ 61535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BN": function() { return /* binding */ cateringCategoriesQuestion; },
/* harmony export */   "TN": function() { return /* binding */ PRICE_PER_PERSON_OF_CATEGORY; },
/* harmony export */   "kl": function() { return /* binding */ isValidCateringCategory; },
/* harmony export */   "sF": function() { return /* binding */ CATERING_CATEGORY_ITEMS; }
/* harmony export */ });
/* unused harmony export CATERING_CATEGORIES */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var lib_yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33448);
/* harmony import */ var qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56274);



var CATERING_CATEGORIES = [
    "breakfast",
    "fingerfood",
    "business_lunch",
    "cakes_and_sweets",
    "christmas",
    "street_food",
    "drinks",
    "bbq",
    "buffet",
    "fine_dining",
    "summer_party",
    "other",
    "event", 
];
var PRICE_PER_PERSON_OF_CATEGORY = {
    bbq: createCategoryData(15, 20),
    fingerfood: createCategoryData(12, 20),
    breakfast: createCategoryData(11, 15),
    buffet: createCategoryData(14, 20),
    business_lunch: createCategoryData(11, 20),
    cakes_and_sweets: createCategoryData(10, 15),
    christmas: createCategoryData(25, 35),
    summer_party: createCategoryData(35, 45),
    drinks: createCategoryData(11, 20),
    fine_dining: createCategoryData(25, 30),
    other: createCategoryData(15, 25),
    street_food: createCategoryData(25, 40),
    event: createCategoryData(15, 25)
};
function createCategoryData(minValue, defaultValue) {
    return {
        minPricePerPerson: minValue,
        defaultPricePerPerson: defaultValue
    };
}
var CATERER_CATERING_CATEGORY = (/* unused pure expression or super */ null && ([
    "Breakfast",
    "Fingerfood & Snacks",
    "Business Lunch",
    "Cake & Sweets",
    "Foodtruck/Streetfood",
    "Drinks & Cocktails",
    "Buffet",
    "Dinner & Fine Dining", 
]));
var CATERER_CATERING_CATEGORY_MAPPING = {
    Breakfast: "breakfast",
    Buffet: "buffet",
    "Business Lunch": "business_lunch",
    "Cake & Sweets": "cakes_and_sweets",
    "Dinner & Fine Dining": "fine_dining",
    "Drinks & Cocktails": "drinks",
    "Fingerfood & Snacks": "fingerfood",
    "Foodtruck/Streetfood": "street_food"
};
function isValidCateringCategory(value) {
    return CATERING_CATEGORIES.includes(value);
}
var CATERING_CATEGORY_ITEMS = [
    {
        value: "breakfast",
        labelEn: "Breakfast",
        labelDe: "Fr\xfchst\xfcck",
        image: "/artifacts/images/survey/occasion/breakfast.webp"
    },
    {
        value: "fingerfood",
        labelEn: "Fingerfood & Snacks",
        labelDe: "Fingerfood & Snacks",
        image: "/artifacts/images/survey/occasion/fingerfood.webp"
    },
    {
        value: "business_lunch",
        labelEn: "Lunch",
        labelDe: "Lunch",
        image: "/artifacts/images/survey/occasion/lunch.webp"
    },
    {
        value: "cakes_and_sweets",
        labelEn: "Cakes & Sweets",
        labelDe: "Kuchen & S\xfc\xdfes",
        image: "/artifacts/images/survey/occasion/cakes_and_sweets.webp"
    },
    {
        value: "street_food",
        labelEn: "Food Truck",
        labelDe: "Foodtruck",
        image: "/artifacts/images/survey/occasion/foodtruck.webp"
    },
    {
        value: "christmas",
        labelEn: "Christmas",
        labelDe: "Weihnachten",
        image: "/artifacts/images/survey/occasion/christmas.webp"
    },
    {
        value: "drinks",
        labelEn: "Drinks & Cocktails",
        labelDe: "Getr\xe4nke & Cocktails",
        image: "/artifacts/images/survey/occasion/drinks_and_cocktails.webp"
    },
    {
        value: "buffet",
        labelEn: "Buffet",
        labelDe: "Buffet",
        image: "/artifacts/images/survey/occasion/buffet.webp"
    },
    {
        value: "fine_dining",
        labelEn: "Dinner & Fine Dining",
        labelDe: "Dinner & Fine Dining",
        image: "/artifacts/images/survey/occasion/dinner.webp"
    },
    {
        value: "other",
        labelEn: "I am not sure",
        labelDe: "Ich bin mir nicht sicher",
        image: "/artifacts/images/survey/occasion/other.webp"
    }, 
];
var cateringCategoriesQuestion = Object.freeze((0,qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_1__/* .createSelectorQuestion */ .iX)({
    id: "catering_categories",
    getValidator: function(param) {
        var selectedCaterer = param.selectedCaterer;
        var supportedCategoryValues = getSupportedCategories(selectedCaterer);
        return lib_yup__WEBPACK_IMPORTED_MODULE_0__/* ["default"].array */ .Z.array().of(lib_yup__WEBPACK_IMPORTED_MODULE_0__/* ["default"].mixed */ .Z.mixed().strict().required().oneOf(supportedCategoryValues)).min(1).required();
    },
    getItems: function(param) {
        var selectedCaterer = param.selectedCaterer;
        var supportedCategoryValues = getSupportedCategories(selectedCaterer);
        return CATERING_CATEGORY_ITEMS.filter(function(item) {
            return supportedCategoryValues.includes(item.value);
        });
    }
}));
function getSupportedCategories(caterer) {
    if (caterer) {
        return Array.from(new Set(caterer.catering_categories.map(function(category) {
            return CATERER_CATERING_CATEGORY_MAPPING[category] || "other";
        })));
    }
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(CATERING_CATEGORIES);
}


/***/ }),

/***/ 26407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vv": function() { return /* binding */ cityQuestion; },
/* harmony export */   "fF": function() { return /* binding */ CITY_QUESTION_ITEMS; },
/* harmony export */   "m0": function() { return /* binding */ isValidCity; },
/* harmony export */   "pv": function() { return /* binding */ cityStep; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95197);
/* harmony import */ var lib_yup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33448);
/* harmony import */ var qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(56274);
/* harmony import */ var shared_svg_cities_Berlin__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7489);
/* harmony import */ var shared_svg_cities_Cologne__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30947);
/* harmony import */ var shared_svg_cities_Dusseldorf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84786);
/* harmony import */ var shared_svg_cities_FrankfurtMain__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16707);
/* harmony import */ var shared_svg_cities_Hamburg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(91689);
/* harmony import */ var shared_svg_cities_Munich__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38595);
/* harmony import */ var shared_svg_cities_Other__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(98839);
/* harmony import */ var shared_svg_cities_Stuttgart__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(61737);














var CITY_VALUES = [
    "muenchen",
    "berlin",
    "frankfurt-am-main",
    "hamburg",
    "duesseldorf",
    "koeln",
    "stuttgart",
    "other", 
];
var CITY_QUESTION_ITEMS = [
    {
        labelEn: "Munich",
        labelDe: "M\xfcnchen",
        value: "muenchen",
        imageComponent: shared_svg_cities_Munich__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z
    },
    {
        labelEn: "Berlin",
        labelDe: "Berlin",
        value: "berlin",
        imageComponent: shared_svg_cities_Berlin__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z
    },
    {
        labelEn: "Frankfurt am Main",
        labelDe: "Frankfurt am Main",
        value: "frankfurt-am-main",
        imageComponent: shared_svg_cities_FrankfurtMain__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z
    },
    {
        labelEn: "Hamburg",
        labelDe: "Hamburg",
        value: "hamburg",
        imageComponent: shared_svg_cities_Hamburg__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z
    },
    {
        labelEn: "Dusseldorf",
        labelDe: "D\xfcsseldorf",
        value: "duesseldorf",
        imageComponent: shared_svg_cities_Dusseldorf__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z
    },
    {
        labelEn: "Cologne",
        labelDe: "K\xf6ln",
        value: "koeln",
        imageComponent: shared_svg_cities_Cologne__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z
    },
    {
        labelEn: "Stuttgart",
        labelDe: "Stuttgart",
        value: "stuttgart",
        imageComponent: shared_svg_cities_Stuttgart__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z
    },
    {
        value: "other",
        labelEn: "Other City",
        labelDe: "Sonstige Stadt",
        imageComponent: function() {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_2__.Box, {
                height: "80px",
                width: "80px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_svg_cities_Other__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    width: "24px"
                })
            });
        }
    }, 
];
var cityQuestion = Object.freeze((0,qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_12__/* .createSelectorQuestion */ .iX)({
    id: "city",
    getValidator: function(param) {
        var selectedCaterer = param.selectedCaterer;
        var supportedCityValues = getSupportedCityValues(selectedCaterer);
        return lib_yup__WEBPACK_IMPORTED_MODULE_3__/* ["default"].mixed */ .Z.mixed().oneOf(supportedCityValues).required();
    },
    getItems: function(param) {
        var selectedCaterer = param.selectedCaterer;
        var supportedCityValues = getSupportedCityValues(selectedCaterer);
        return CITY_QUESTION_ITEMS.filter(function(param) {
            var value = param.value;
            return supportedCityValues.includes(value);
        });
    }
}));
var cityStep = Object.freeze((0,qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_12__/* .createStep */ .yW)({
    id: "city",
    questions: [
        cityQuestion
    ],
    content: {
        titleEn: "Select your City",
        titleDe: "W\xe4hle deine Stadt"
    }
}));
function getSupportedCityValues(caterer) {
    var supportedCityValues = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(CITY_VALUES);
    if (caterer) {
        supportedCityValues = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(CITY_VALUES.filter(function(city) {
            return caterer.city_slugs.includes(city);
        }));
        var catererSupportsNonDefaultCities = Boolean(caterer && caterer.city_slugs.some(function(city) {
            return !CITY_VALUES.includes(city);
        }));
        if (catererSupportsNonDefaultCities) {
            supportedCityValues.push("other");
        }
    }
    return supportedCityValues;
}
function isValidCity(value) {
    return CITY_VALUES.includes(value);
}


/***/ }),

/***/ 56274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CB": function() { return /* binding */ createQuestion; },
/* harmony export */   "CX": function() { return /* binding */ createDateQuestion; },
/* harmony export */   "iX": function() { return /* binding */ createSelectorQuestion; },
/* harmony export */   "yW": function() { return /* binding */ createStep; }
/* harmony export */ });
function createSelectorQuestion(question) {
    return question;
}
function createDateQuestion(question) {
    return question;
}
function createStep(options) {
    return options;
}
function createQuestion(options) {
    return options;
}


/***/ }),

/***/ 44955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$A": function() { return /* binding */ identifyUser; },
/* harmony export */   "De": function() { return /* binding */ trackConversion; },
/* harmony export */   "zz": function() { return /* binding */ pushDataLayer; }
/* harmony export */ });
/* unused harmony export getIdentity */
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55877);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(uuid__WEBPACK_IMPORTED_MODULE_0__);


var STORAGE_KEY = "_heycater_identity";
var USER_IDENTITY_VALUE = (0,uuid__WEBPACK_IMPORTED_MODULE_0__.v4)();
function getIdentity() {
    if (!doesLocalStorageExist()) {
        return USER_IDENTITY_VALUE;
    }
    if (!localStorage.getItem(STORAGE_KEY)) {
        localStorage.setItem(STORAGE_KEY, USER_IDENTITY_VALUE);
    }
    return localStorage.getItem(STORAGE_KEY);
}
function identifyUser(identity) {
    window.gtag && window.gtag("config", "G-856Y5131LS", {
        user_id: identity
    });
    window.analytics && window.analytics.identify(identity);
}
function pushDataLayer(uuid) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        userId: uuid
    });
}
function trackConversion() {
    var properties = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    window.analytics && window.analytics.track("conversion", properties);
}


/***/ }),

/***/ 6619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HL": function() { return /* binding */ cityMappingByLocale; },
  "r$": function() { return /* binding */ findCitySlug; },
  "iZ": function() { return /* binding */ getCityInLocalStorage; },
  "el": function() { return /* binding */ persistCityInLocalStorage; }
});

// UNUSED EXPORTS: cityFromUrlSlug, cityKeyFromURLSlug, findCityNameByLocale, getCityFromURLParams, getValueInLocalStorage, localizedCityFromURLSlug

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(82222);
// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__(93555);
// EXTERNAL MODULE: ./src/shared/constants.ts
var constants = __webpack_require__(98769);
;// CONCATENATED MODULE: ./src/shared/helpers/localStorageExists.js
var localStorageExistence = undefined;
var WRITE_TEST_KEY = "_heycater_write_test";
function localStorageExists_doesLocalStorageExist() {
    if (typeof localStorageExistence === "undefined") {
        try {
            localStorage.setItem(WRITE_TEST_KEY, "1");
            localStorage.removeItem(WRITE_TEST_KEY);
            localStorageExistence = true;
        } catch (_err) {
            localStorageExistence = false;
        }
    }
    return localStorageExistence;
}

;// CONCATENATED MODULE: ./src/shared/helpers/cities.js







var cityMappingByLocale = function() {
    var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "de";
    var ref;
    var parsedLocale = (0,i18n/* getFallbackForLocale */.rh)(locale || "de");
    var translation = (ref = i18n/* localeResources */.jy[parsedLocale]) === null || ref === void 0 ? void 0 : ref.common;
    return (0,_object_spread/* default */.Z)({}, translation.cities, translation.citiesUK, translation.citiesAustria, translation.citiesSwitzerland, translation.citiesDenmark);
};
var cityFromUrlSlug = function(param) {
    var slug = param.slug, locale = param.locale;
    var URLParts = slug.split("-");
    var citiesMapping = cityMappingByLocale(locale);
    var foundEntry = Object.entries(citiesMapping).find(function(param) {
        var _param = _sliced_to_array(param, 1), cityKey = _param[0];
        return URLParts.includes(cityKey.split("-")[0]);
    });
    if (!foundEntry) {
        return null;
    }
    var _foundEntry = _sliced_to_array(foundEntry, 2), cityKey = _foundEntry[0], localizedCity = _foundEntry[1];
    return {
        cityKey: cityKey,
        localizedCity: localizedCity
    };
};
var localizedCityFromURLSlug = function(param) {
    var slug = param.slug, _locale = param.locale, locale = _locale === void 0 ? "de" : _locale;
    var ref;
    return ((ref = cityFromUrlSlug({
        slug: slug,
        locale: locale
    })) === null || ref === void 0 ? void 0 : ref.localizedCity) || null;
};
var cityKeyFromURLSlug = function(param) {
    var slug = param.slug, locale = param.locale;
    var ref;
    return ((ref = cityFromUrlSlug({
        slug: slug,
        locale: locale
    })) === null || ref === void 0 ? void 0 : ref.cityKey) || null;
};
var getCityFromURLParams = function() {
    if (false) {}
    var city = parse(window.location.search, {
        ignoreQueryPrefix: true
    }).city;
    return Object.keys(cityMappingByLocale()).includes(city) ? city : null;
};
var PERSISTED_CITY_KEY = "_heycater_city";
var persistCityInLocalStorage = function(city) {
    if (!city) return;
    if (localStorageExists_doesLocalStorageExist()) {
        localStorage.setItem(PERSISTED_CITY_KEY, city);
    }
};
var getValueInLocalStorage = function(key) {
    if (doesLocalStorageExist()) {
        return localStorage.getItem("_heycater_".concat(key));
    }
};
var getCityInLocalStorage = function() {
    if (localStorageExists_doesLocalStorageExist()) {
        return localStorage.getItem(PERSISTED_CITY_KEY);
    }
};
var findCitySlug = function(cityName) {
    if (!cityName) return null;
    var cityNameLower = cityName.toLowerCase();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var locale = _step.value;
            var cities = cityMappingByLocale(locale);
            if (cities[cityNameLower]) {
                return {
                    v: cityNameLower
                };
            }
            var citySlug = Object.keys(cities).find(function(key) {
                var ref;
                return ((ref = cities[key]) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === cityNameLower;
            });
            if (citySlug) return {
                v: citySlug
            };
        };
        for(var _iterator = constants/* LOCALES */.lE[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            if ((0,_type_of/* default */.Z)(_ret) === "object") return _ret.v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
};
var findCityNameByLocale = function(key) {
    var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en";
    var cities = cityMappingByLocale(locale);
    return cities[key];
};


/***/ }),

/***/ 10045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useAuthentication; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92432);
/* harmony import */ var lib_graphql_mutations__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26540);
/* harmony import */ var qualification_hooks_useCurrentUser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(866);






function useAuthentication() {
    var ref = (0,qualification_hooks_useCurrentUser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(), refetchCurrentUser = ref.refetch;
    var client = (0,urql__WEBPACK_IMPORTED_MODULE_3__/* .useClient */ .m8)();
    var login = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(variables) {
            var ref, _data, _authenticateUser, authToken, userAccount, onSubmitResponse;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,lib_graphql_mutations__WEBPACK_IMPORTED_MODULE_1__/* .authenticateUser */ .So)(variables.email, variables.password, {
                                client: client
                            })
                        ];
                    case 1:
                        ref = _state.sent(), _data = ref.data, _authenticateUser = _data.authenticateUser, authToken = _authenticateUser.authToken, userAccount = _authenticateUser.userAccount;
                        onSubmitResponse = function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                                    localStorage.setItem("token", authToken);
                                    refetchCurrentUser({
                                        requestPolicy: "network-only"
                                    });
                                    return [
                                        2,
                                        {
                                            userAccount: userAccount
                                        }
                                    ];
                                });
                            });
                            return function onSubmitResponse() {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        return [
                            4,
                            onSubmitResponse()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                authToken: authToken,
                                userAccount: userAccount
                            }
                        ];
                }
            });
        });
        return function(variables) {
            return _ref.apply(this, arguments);
        };
    }(), [
        refetchCurrentUser
    ]);
    var logout = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        localStorage.removeItem("token");
        refetchCurrentUser({
            requestPolicy: "network-only"
        });
    }, []);
    return {
        login: login,
        logout: logout
    };
}


/***/ }),

/***/ 48107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layouts_Navigation; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Hidden/Hidden.js + 3 modules
var Hidden = __webpack_require__(53450);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/ButtonBase.js + 4 modules
var ButtonBase = __webpack_require__(41810);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/AccountCircle.js
var AccountCircle = __webpack_require__(19814);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ArrowForward.js
var ArrowForward = __webpack_require__(29973);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var Close = __webpack_require__(80366);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/KeyboardArrowDown.js
var KeyboardArrowDown = __webpack_require__(51115);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/KeyboardArrowUp.js
var KeyboardArrowUp = __webpack_require__(25281);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./src/lib/cssVariables.js
var cssVariables = __webpack_require__(75150);
// EXTERNAL MODULE: ./src/qualification/hooks/useBreakpoints.ts
var useBreakpoints = __webpack_require__(19916);
// EXTERNAL MODULE: ./src/qualification/hooks/useCurrentUser.ts + 1 modules
var useCurrentUser = __webpack_require__(866);
// EXTERNAL MODULE: ./src/shared/constants.ts
var constants = __webpack_require__(98769);
// EXTERNAL MODULE: ./src/shared/helpers/urls.ts
var urls = __webpack_require__(6880);
// EXTERNAL MODULE: ./src/shared/hooks/useAuthentication.ts
var useAuthentication = __webpack_require__(10045);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
;// CONCATENATED MODULE: ./src/shared/hooks/useElementSize.js


function useElementSize() {
    var debounce = function debounce(fn, delay) {
        var timeoutId;
        return function debouncedFn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _this = this;
            clearTimeout(timeoutId);
            timeoutId = setTimeout(function() {
                return fn.apply(_this, args);
            }, delay);
        };
    };
    var ref = (0,react.useState)({
        width: 0,
        height: 0
    }), size = ref[0], setSize = ref[1];
    var prevSizeRef = (0,react.useRef)({
        width: 0,
        height: 0
    });
    var ref1 = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var element = ref1.current;
        var handleResize = debounce(function(entries) {
            var _contentRect = entries[0].contentRect, newWidth = _contentRect.width, newHeight = _contentRect.height;
            if (prevSizeRef.current.width !== newWidth || prevSizeRef.current.height !== newHeight) {
                prevSizeRef.current = {
                    width: newWidth,
                    height: newHeight
                };
                setSize({
                    width: newWidth,
                    height: newHeight
                });
            }
        }, 100);
        var resizeObserver = new ResizeObserver(handleResize);
        if (element) {
            resizeObserver.observe(element);
        }
        return function() {
            if (element) {
                resizeObserver.unobserve(element);
            }
        };
    }, [
        ref1
    ]);
    return (0,_object_spread/* default */.Z)({
        ref: ref1
    }, size);
}

// EXTERNAL MODULE: ./src/shared/services/trustedShops/handleRatings.ts
var handleRatings = __webpack_require__(95046);
// EXTERNAL MODULE: ./src/shared/svg/Logo.js
var Logo = __webpack_require__(37582);
;// CONCATENATED MODULE: ./src/shared/svg/MenuIcon.js


function MenuIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "26",
        height: "16",
        viewBox: "0 0 26 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "26",
                height: "2",
                rx: "1",
                fill: "#374C19"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "11",
                y: "7",
                width: "15",
                height: "2",
                rx: "1",
                fill: "#374C19"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                y: "14",
                width: "26",
                height: "2",
                rx: "1",
                fill: "#374C19"
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/shared/svg/TrustedShopsLogo.tsx
var TrustedShopsLogo = __webpack_require__(36902);
// EXTERNAL MODULE: ./src/shared/svg/TrustedShopsStars.js
var TrustedShopsStars = __webpack_require__(95359);
// EXTERNAL MODULE: ./src/static_pages/marketing_pages/helpers.ts
var helpers = __webpack_require__(10904);
// EXTERNAL MODULE: ./src/system/components/Container.tsx
var Container = __webpack_require__(10758);
;// CONCATENATED MODULE: ./src/shared/layouts/Navigation.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 100;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        ";\n  background: white;\n  z-index: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  height: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  display: flex;\n  justify-content: center;\n\n  ",
        " {\n    display: block;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 150px;\n  height: ",
        ";\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n\n  & > span {\n    display: inline-flex;\n    margin-left: 10px;\n    font-size: 18px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: contents;\n\n  ",
        " {\n    display: ",
        ";\n    position: fixed;\n    top: var(",
        ");\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: ",
        ";\n    background: white;\n    overflow-y: auto;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  ",
        " {\n    display: block;\n    padding: 8px 0;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  list-style: none;\n  margin: 0;\n  padding-left: 0;\n  align-items: center;\n\n  ",
        " {\n    display: block;\n    flex-grow: unset;\n    width: 100%;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  min-height: ",
        ";\n  display: flex;\n  align-items: center;\n\n  ",
        " {\n    display: block;\n    min-height: auto;\n  }\n\n  ",
        " {\n    &[data-dropdown='true'] > .navigation-dropdown {\n      display: block;\n      pointer-events: none;\n    }\n\n    &[data-dropdown='true']:hover > .navigation-dropdown {\n      pointer-events: auto;\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: auto;\n\n  ",
        " {\n    border-bottom: none;\n    margin: ",
        ";\n\n    > a {\n      font-weight: ",
        ";\n      display: ",
        ";\n      justify-content: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  min-height: ",
        ";\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 16px;\n  border: none;\n  background: inherit;\n  display: flex;\n  width: 100%;\n  margin-right: 0;\n  flex-grow: 1;\n  text-decoration: none;\n  font-size: 15px;\n  font-family: inherit;\n  cursor: pointer;\n  font-weight: 500;\n  align-items: center;\n  white-space: nowrap;\n  a {\n    text-decoration: none;\n    color: inherit;\n  }\n\n  &,\n  &:hover {\n    color: ",
        ";\n  }\n\n  ",
        " {\n    font-weight: 700;\n    justify-content: space-between;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 16px;\n  text-decoration: none;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n  color: ",
        ";\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: white;\n  min-height: 30px;\n  overflow: hidden;\n  position: absolute;\n  top: ",
        ";\n  z-index: ",
        ";\n  padding: 8px;\n  left: 0;\n  min-width: 260px;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  display: none;\n  opacity: 0;\n  transform: translateY(8px);\n  transition: opacity 0.25s ease, transform 0.25s ease;\n\n  [data-dropdown='true']:hover > & {\n    opacity: 1;\n    transform: translateY(0);\n  }\n\n  ",
        " {\n    position: static;\n    background: transparent;\n    padding: 0 30px;\n    left: 0;\n    width: 100%;\n    border: none;\n    border-radius: 0;\n    box-shadow: none;\n    border-top: 1px solid ",
        ";\n    border-bottom: 1px solid ",
        ";\n    background: rgba(0, 0, 0, 0.03);\n    display: ",
        ";\n    opacity: 1;\n    transform: none;\n    transition: none;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 4px;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 12px;\n  border: none;\n  background: inherit;\n  cursor: pointer;\n  color: ",
        ";\n  text-decoration: none;\n  font-size: 16px;\n  font-weight: 500;\n  border-radius: 8px;\n  width: 100%;\n  text-align: left;\n  font-family: inherit;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.04);\n\n    svg {\n      transform: rotate(-45deg);\n    }\n  }\n\n  svg {\n    color: ",
        ";\n    flex-shrink: 0;\n    margin-left: 16px;\n    transition: transform 0.25s ease;\n  }\n\n  ",
        " {\n    font-size: 15px;\n    padding: 14px 8px;\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  && {\n    background-color: #f95542;\n    color: white;\n    border-radius: 100px;\n    padding: 10px 24px;\n    font-weight: 600;\n    font-size: 15px;\n    text-transform: none;\n    white-space: nowrap;\n    box-shadow: none;\n\n    &:hover {\n      background-color: #e04a39;\n      box-shadow: none;\n    }\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  min-height: ",
        ";\n  display: flex;\n  align-items: center;\n  list-style: none;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  padding: 8px 12px;\n  border: none;\n  background: inherit;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n  color: ",
        ";\n  white-space: nowrap;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: white;\n  position: absolute;\n  top: ",
        ";\n  z-index: ",
        ";\n  padding: 8px;\n  left: 0;\n  min-width: 140px;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  display: none;\n  opacity: 0;\n  transform: translateY(8px);\n  transition: opacity 0.25s ease, transform 0.25s ease;\n\n  ",
        " {\n    ",
        ":hover > &,\n    &[aria-expanded='true'] {\n      display: block;\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  ",
        " {\n    position: static;\n    width: 100%;\n    border-radius: 0;\n    box-shadow: none;\n    opacity: 1;\n    transform: none;\n    transition: none;\n    display: ",
        ";\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      font-weight: 700;\n    "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  padding: 8px 12px;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n  color: ",
        ";\n  border-radius: 6px;\n  cursor: pointer;\n\n  &:hover {\n    background: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0px 20px;\n  margin-left: auto;\n  left: 16px;\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 4px;\n  background-color: ",
        ";\n  color: white;\n  font-size: 12px;\n  z-index: ",
        ";\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 10px;\n  justify-content: space-between;\n\n  ",
        " {\n    justify-content: center;\n  }\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 6px;\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  color: white;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 17px;\n  width: 100%;\n  min-width: 70px;\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 12px;\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: inherit;\n  text-decoration: inherit;\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}



























var LOCALE_OPTIONS = [
    {
        label: "DE",
        locale: "de"
    },
    {
        label: "EN",
        locale: "en"
    },
    {
        label: "EN (UK)",
        locale: "en-uk"
    }, 
];
function getLocaleLabel(locale) {
    if (!locale) return "EN";
    if (locale === "en-uk") return "EN (UK)";
    if (locale.startsWith("de")) return "DE";
    return "EN";
}
function Navigation(param) {
    var hideNavigationLinks = param.hideNavigationLinks, renderCTA = param.renderCTA, ratings = param.ratings, mainLinks = param.mainLinks;
    var t = (0,useTranslation/* useTranslation */.$)("static_pages").t;
    var ref = (0,react.useState)(null), visibleDropdown = ref[0], setVisibleDropdown = ref[1];
    var ref1 = (0,react.useState)(false), mobileMenuOpen = ref1[0], setMobileMenuOpen = ref1[1];
    var mobile = (0,useBreakpoints/* useBreakpointDown */.a)("sm");
    var dropdownTimeoutRef = (0,react.useRef)(null);
    var onToggleDropdownVisibility = react.useCallback(function(name) {
        if (name === visibleDropdown) {
            setVisibleDropdown(null);
        } else {
            setVisibleDropdown(name);
        }
    }, [
        visibleDropdown
    ]);
    var onMouseEnterDropdown = react.useCallback(function(name) {
        if (dropdownTimeoutRef.current) {
            clearTimeout(dropdownTimeoutRef.current);
            dropdownTimeoutRef.current = null;
        }
        setVisibleDropdown(name);
    }, []);
    var onMouseLeaveDropdown = react.useCallback(function() {
        dropdownTimeoutRef.current = setTimeout(function() {
            setVisibleDropdown(null);
        }, 150);
    }, []);
    var ref2 = useElementSize(), navRef = ref2.ref, navHeight = ref2.height;
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        cssVariables/* cssVars.topBarHeight.setValue */.D.topBarHeight.setValue("".concat(Math.floor(navHeight), "px"));
        return function() {
            return cssVariables/* cssVars.topBarHeight.setValue */.D.topBarHeight.setValue(0);
        };
    }, [
        navHeight
    ]);
    var ref3 = (0,useCurrentUser/* default */.Z)(), currentUserAccount = ref3.currentUserAccount, loading = ref3.loading;
    var logout = (0,useAuthentication/* default */.Z)().logout;
    var isLoggedIn = !loading && currentUserAccount;
    var topLinks = mainLinks || [
        {
            href: "",
            label: t("common:navigation.services"),
            children: [
                {
                    href: "/heykantine",
                    label: t("common:navigation.dailyOfficeMeals")
                },
                {
                    href: "/meeting-event-catering",
                    label: t("common:navigation.meetingsCatering")
                },
                {
                    href: "/events",
                    label: t("common:navigation.fullServiceEvents")
                },
                {
                    href: "/pantry",
                    label: t("common:navigation.officeDrinksSnack")
                }, 
            ]
        },
        {
            href: "",
            label: t("common:navigation.about"),
            children: [
                {
                    href: "/about-us",
                    label: t("common:navigation.aboutUs")
                },
                {
                    href: "/nachhaltigkeit",
                    label: t("common:navigation.sustainability")
                },
                {
                    href: "/hub",
                    label: t("common:navigation.blog")
                }, 
            ]
        },
        {
            href: "",
            label: t("common:navigation.forPartners"),
            children: [
                {
                    href: "/partner-page",
                    label: t("common:navigation.becomePartner")
                }, 
            ]
        },
        {
            href: "",
            label: t("common:navigation.more"),
            children: [
                {
                    href: constants/* LINKS.career */.BA.career,
                    label: t("common:navigation.career"),
                    outsideLink: true
                },
                {
                    href: "".concat(urls/* CUSTOMER_APP_HOST */._R, "/account/login"),
                    label: t("common:navigation.signIn"),
                    outsideLink: true
                },
                {
                    href: "/impressum",
                    label: t("common:navigation.imprint")
                },
                {
                    href: "/presse",
                    label: t("common:navigation.press")
                },
                {
                    href: "/contact-01",
                    label: t("common:navigation.contact")
                }, 
            ]
        }, 
    ];
    var userMenuLinks = function() {
        var ref, ref1;
        var menuList = [];
        if (currentUserAccount === null || currentUserAccount === void 0 ? void 0 : (ref = currentUserAccount.roles) === null || ref === void 0 ? void 0 : ref.includes("HEYKANTINE_CONSUMER")) {
            menuList.push({
                href: "".concat(urls/* CUSTOMER_APP_HOST */._R, "/kantine/home"),
                label: t("common:navigation.heykantine")
            });
            return menuList;
        }
        menuList = [
            {
                href: (0,helpers/* buildFunnelUrl */.$e)({
                    router: router
                }),
                label: t("common:labels.requestCatering")
            },
            {
                href: "".concat(urls/* CUSTOMER_APP_HOST */._R, "/account/requests"),
                label: t("common:navigation.events")
            },
            {
                href: "".concat(urls/* CUSTOMER_APP_HOST */._R, "/account"),
                label: t("common:navigation.account")
            }, 
        ];
        if (currentUserAccount === null || currentUserAccount === void 0 ? void 0 : (ref1 = currentUserAccount.owner) === null || ref1 === void 0 ? void 0 : ref1.heykantineEnabled) {
            menuList.push({
                href: "".concat(urls/* CUSTOMER_APP_HOST */._R, "/account/kantine"),
                label: t("common:navigation.heykantine")
            });
        }
        return menuList;
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavWrapper, {
        ref: navRef,
        className: "main-navigation",
        style: {
            minHeight: "inherit"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarEyebrow, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    as: "header",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavbarEyebrowFlexWrapper, {
                        children: [
                            mobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(TrustedShopsWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stars, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrustedShopsStars/* default */.Z, {})
                                    }),
                                    ratings && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Rating, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: (0,handleRatings/* formatRating */.A6)((0,handleRatings/* getRating */.h1)(ratings))
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RatingText, {
                                                        children: [
                                                            "\xa0",
                                                            t("trustedShops.ratingText")
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingCount, {
                                                children: t("trustedShops.ratingCount", {
                                                    amount: (0,handleRatings/* formatRatingCount */.mj)((0,handleRatings/* getRatingCount */.cz)(ratings))
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TSLogoBox, {
                                        display: "flex",
                                        alignItems: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrustedShopsLogo/* default */.Z, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PhoneLink, {
                                href: constants/* CONTACT_PHONE.href */.Y.href,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: t("common:navigation.questions")
                                    }),
                                    constants/* CONTACT_PHONE.formatted */.Y.formatted
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavbarWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLeft, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLogo, {
                                    href: "https://www.heycater.com",
                                    "aria-label": "Home",
                                    id: "navbar-logo",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {})
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarCenter, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileMenuOverlay, {
                                    open: mobileMenuOpen,
                                    children: [
                                        !hideNavigationLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuList, {
                                            children: topLinks.map(function(link) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuListItem, {
                                                        "data-dropdown": !!link.children,
                                                        onMouseEnter: !mobile && link.children ? function() {
                                                            return onMouseEnterDropdown(link.label);
                                                        } : undefined,
                                                        onMouseLeave: !mobile && link.children ? onMouseLeaveDropdown : undefined,
                                                        children: [
                                                            link.children ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuListItemLink, {
                                                                as: "button",
                                                                "aria-expanded": visibleDropdown === link.label,
                                                                onClick: function() {
                                                                    return onToggleDropdownVisibility(link.label);
                                                                },
                                                                children: [
                                                                    link.label,
                                                                    mobile && (visibleDropdown === link.label ? /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowUp/* default */.Z, {
                                                                        fontSize: "small"
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowDown/* default */.Z, {
                                                                        fontSize: "small"
                                                                    }))
                                                                ]
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: link.href,
                                                                passHref: true,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuListItemLink, {
                                                                    children: link.label
                                                                })
                                                            }),
                                                            link.children && /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownContent, {
                                                                visible: visibleDropdown === link.label,
                                                                "aria-expanded": visibleDropdown === link.label,
                                                                className: "navigation-dropdown",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownMenu, {
                                                                    children: link.children.map(function(child) {
                                                                        return child.outsideLink ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownMenuLink, {
                                                                            href: child.href,
                                                                            target: "_blank",
                                                                            rel: "noopener noreferrer",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    children: child.label
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                                                                    fontSize: "small"
                                                                                })
                                                                            ]
                                                                        }, child.href) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                            href: child.href,
                                                                            passHref: true,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownMenuLink, {
                                                                                target: "_blank",
                                                                                rel: "noopener noreferrer",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        children: child.label
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                                                                        fontSize: "small"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }, child.href);
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }, link.label);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileOnlyRightSection, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuList, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocaleMenuListItem, {
                                                        "data-dropdown": "true",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocaleButton, {
                                                                as: "button",
                                                                "aria-expanded": visibleDropdown === "locale",
                                                                onClick: function() {
                                                                    return onToggleDropdownVisibility("locale");
                                                                },
                                                                children: [
                                                                    getLocaleLabel(router.locale),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowDown/* default */.Z, {
                                                                        fontSize: "small"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocaleDropdownContent, {
                                                                visible: visibleDropdown === "locale",
                                                                "aria-expanded": visibleDropdown === "locale",
                                                                className: "navigation-dropdown",
                                                                children: LOCALE_OPTIONS.map(function(param) {
                                                                    var label = param.label, locale = param.locale;
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: router.asPath,
                                                                        locale: locale,
                                                                        passHref: true,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocaleOption, {
                                                                            selected: router.locale === locale,
                                                                            children: label
                                                                        })
                                                                    }, locale);
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    !isLoggedIn && !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuListItemRight, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginLink, {
                                                            href: "".concat(urls/* CUSTOMER_APP_HOST */._R, "/account/login"),
                                                            children: t("common:navigation.signIn")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuListItemRight, {
                                                        wrapsButton: true,
                                                        children: typeof renderCTA === "function" ? renderCTA() : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: (0,helpers/* buildFunnelUrl */.$e)({
                                                                router: router
                                                            }),
                                                            passHref: true,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAButton, {
                                                                component: "a",
                                                                rel: "noopener",
                                                                id: "navbar-find-caterers-mobile",
                                                                children: t("common:navigation.requestNow")
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavbarRight, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RightMenuList, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocaleMenuListItem, {
                                                "data-dropdown": "true",
                                                onMouseEnter: function() {
                                                    return onMouseEnterDropdown("locale");
                                                },
                                                onMouseLeave: onMouseLeaveDropdown,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocaleButton, {
                                                        as: "button",
                                                        "aria-expanded": visibleDropdown === "locale",
                                                        onClick: function() {
                                                            return onToggleDropdownVisibility("locale");
                                                        },
                                                        children: [
                                                            getLocaleLabel(router.locale),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowDown/* default */.Z, {
                                                                fontSize: "small"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocaleDropdownContent, {
                                                        visible: visibleDropdown === "locale",
                                                        "aria-expanded": visibleDropdown === "locale",
                                                        children: LOCALE_OPTIONS.map(function(param) {
                                                            var label = param.label, locale = param.locale;
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: router.asPath,
                                                                locale: locale,
                                                                passHref: true,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocaleOption, {
                                                                    selected: router.locale === locale,
                                                                    children: label
                                                                })
                                                            }, locale);
                                                        })
                                                    })
                                                ]
                                            }),
                                            !isLoggedIn && !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuListItemRight, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginLink, {
                                                    href: "".concat(urls/* CUSTOMER_APP_HOST */._R, "/account/login"),
                                                    children: t("common:navigation.signIn")
                                                })
                                            }),
                                            isLoggedIn && !loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuListItemRight, {
                                                "data-dropdown": "true",
                                                onMouseEnter: function() {
                                                    return onMouseEnterDropdown("account");
                                                },
                                                onMouseLeave: onMouseLeaveDropdown,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuListItemLink, {
                                                        as: "button",
                                                        "aria-expanded": visibleDropdown === "account",
                                                        onClick: function() {
                                                            return onToggleDropdownVisibility("account");
                                                        },
                                                        children: [
                                                            currentUserAccount.firstName,
                                                            " ",
                                                            currentUserAccount.lastName,
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                                                display: "flex",
                                                                alignItems: "center",
                                                                ml: 1,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountCircle/* default */.Z, {})
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownContent, {
                                                        visible: visibleDropdown === "account",
                                                        "aria-expanded": visibleDropdown === "account",
                                                        className: "navigation-dropdown",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownMenu, {
                                                            children: [
                                                                userMenuLinks.map(function(param) {
                                                                    var href = param.href, label = param.label;
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: href,
                                                                        passHref: true,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownMenuLink, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    children: label
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                                                                    fontSize: "small"
                                                                                })
                                                                            ]
                                                                        })
                                                                    }, href);
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownMenuLink, {
                                                                    onClick: logout,
                                                                    as: "button",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                children: t("common:navigation.signOut")
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                                                            fontSize: "small"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuListItemRight, {
                                                wrapsButton: true,
                                                children: typeof renderCTA === "function" ? renderCTA() : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: (0,helpers/* buildFunnelUrl */.$e)({
                                                        router: router
                                                    }),
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAButton, {
                                                        component: "a",
                                                        rel: "noopener",
                                                        id: "navbar-find-caterers",
                                                        children: t("common:navigation.requestNow")
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                                        mdUp: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HamburgerButton, {
                                            "aria-label": mobileMenuOpen ? "Hide Navigation Menu" : "Show Navigation Menu",
                                            onClick: function() {
                                                return setMobileMenuOpen(!mobileMenuOpen);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuListItemSecondary, {
                                                children: mobileMenuOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuIcon, {})
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}
var NavWrapper = styled_components_browser_esm["default"].div(_templateObject());
var Navbar = styled_components_browser_esm["default"].header(_templateObject1(), function(props) {
    return props.theme.navbar.height;
}, function(props) {
    return props.theme.zIndex.appBar;
});
var NavbarWrapper = styled_components_browser_esm["default"].div(_templateObject2(), function(props) {
    return props.theme.navbar.height;
});
var NavbarLeft = styled_components_browser_esm["default"].div(_templateObject3());
var NavbarCenter = styled_components_browser_esm["default"].nav(_templateObject4(), function(props) {
    return props.theme.breakpoints.down("sm");
});
var NavbarRight = styled_components_browser_esm["default"].div(_templateObject5());
var NavbarLogo = styled_components_browser_esm["default"].a(_templateObject6(), function(props) {
    return props.theme.navbar.height;
});
var MobileMenuOverlay = styled_components_browser_esm["default"].div(_templateObject7(), function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.open ? "block" : "none";
}, cssVariables/* cssVars.topBarHeight.name */.D.topBarHeight.name, function(props) {
    return props.theme.zIndex.appBar;
});
var MobileOnlyRightSection = styled_components_browser_esm["default"].div(_templateObject8(), function(props) {
    return props.theme.breakpoints.down("sm");
});
var MenuList = styled_components_browser_esm["default"].ul(_templateObject9(), function(props) {
    return props.theme.breakpoints.down("sm");
});
var RightMenuList = (0,styled_components_browser_esm["default"])(MenuList)(_templateObject10(), function(props) {
    return props.theme.breakpoints.down("sm");
});
var MenuListItem = styled_components_browser_esm["default"].li(_templateObject11(), function(props) {
    return props.theme.navbar.height;
}, function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.theme.breakpoints.up("md");
});
var MenuListItemRight = (0,styled_components_browser_esm["default"])(MenuListItem)(_templateObject12(), function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.wrapsButton ? "8px 8px 0" : "inherit";
}, function(props) {
    return props.wrapsButton ? 600 : 400;
}, function(props) {
    return props.wrapsButton ? "flex" : "inherit";
}, function(props) {
    return props.wrapsButton ? "center" : "initial";
});
var MenuListItemSecondary = (0,styled_components_browser_esm["default"])(MenuListItem)(_templateObject13(), function(props) {
    return props.theme.navbar.height;
});
var MenuListItemLink = styled_components_browser_esm["default"].a(_templateObject14(), function(props) {
    return props.theme.palette.text.primary;
}, function(props) {
    return props.theme.breakpoints.down("sm");
});
var LoginLink = styled_components_browser_esm["default"].a(_templateObject15(), function(props) {
    return props.theme.palette.text.primary;
}, function(props) {
    return props.theme.palette.text.secondary;
});
var DropdownContent = styled_components_browser_esm["default"].div(_templateObject16(), function(props) {
    return props.theme.navbar.height;
}, function(props) {
    return props.theme.zIndex.appBar;
}, function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.theme.palette.grey[200];
}, function(props) {
    return props.theme.palette.grey[200];
}, function(props) {
    return props.visible ? "block" : "none";
});
var DropdownMenu = styled_components_browser_esm["default"].div(_templateObject17());
var DropdownMenuLink = styled_components_browser_esm["default"].a(_templateObject18(), function(param) {
    var theme = param.theme;
    return theme.palette.text.primary;
}, function(param) {
    var theme = param.theme;
    return theme.palette.grey[600];
}, function(props) {
    return props.theme.breakpoints.down("sm");
});
var CTAButton = (0,styled_components_browser_esm["default"])(esm.Button)(_templateObject19());
var LocaleMenuListItem = styled_components_browser_esm["default"].li(_templateObject20(), function(props) {
    return props.theme.navbar.height;
});
var LocaleButton = styled_components_browser_esm["default"].button(_templateObject21(), function(props) {
    return props.theme.palette.text.primary;
});
var LocaleDropdownContent = styled_components_browser_esm["default"].div(_templateObject22(), function(props) {
    return props.theme.navbar.height;
}, function(props) {
    return props.theme.zIndex.appBar;
}, function(props) {
    return props.theme.breakpoints.up("md");
}, LocaleMenuListItem, function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.visible ? "block" : "none";
});
var LocaleOption = styled_components_browser_esm["default"].a(_templateObject24(), function(props) {
    return props.theme.palette.text.primary;
}, function(props) {
    return props.theme.palette.grey[100];
}, function(props) {
    return props.selected && (0,styled_components_browser_esm.css)(_templateObject23());
});
var HamburgerButton = (0,styled_components_browser_esm["default"])(ButtonBase/* default */.Z)(_templateObject25());
var NavbarEyebrow = styled_components_browser_esm["default"].section(_templateObject26(), function(props) {
    return props.theme.palette.grey[800];
}, function(props) {
    return props.theme.zIndex.appBar + 1;
});
var NavbarEyebrowFlexWrapper = styled_components_browser_esm["default"].div(_templateObject27(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.down("xs");
});
var TrustedShopsWrapper = styled_components_browser_esm["default"].div(_templateObject28());
var Stars = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject29());
var RatingText = styled_components_browser_esm["default"].span(_templateObject30(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.down("xs");
});
var RatingCount = styled_components_browser_esm["default"].span(_templateObject31(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.down("md");
});
var Rating = styled_components_browser_esm["default"].span(_templateObject32(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.down("xs");
});
var TSLogoBox = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject33());
var PhoneLink = styled_components_browser_esm["default"].a(_templateObject34());
/* harmony default export */ var layouts_Navigation = (Navigation);


/***/ }),

/***/ 45417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ createOpportunityCreationPayload; }
});

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./src/shared/constants.ts
var constants = __webpack_require__(98769);
// EXTERNAL MODULE: ./src/shared/helpers/analytics.js
var analytics = __webpack_require__(44955);
// EXTERNAL MODULE: ./src/shared/helpers/cities.js + 1 modules
var cities = __webpack_require__(6619);
;// CONCATENATED MODULE: ./src/qualification/services/webToLeadData.ts






var webToLeadData = function(param) {
    var caterer_minimum_order_value = param.caterer_minimum_order_value, _caterer_name = param.caterer_name, caterer_name = _caterer_name === void 0 ? "" : _caterer_name, catering_categories = param.catering_categories, city = param.city, comment = param.comment, company = param.company, conversion_url = param.conversion_url, degree_of_satiation = param.degree_of_satiation, _deliveryAddressStreetAndNumber = param.deliveryAddressStreetAndNumber, deliveryAddressStreetAndNumber = _deliveryAddressStreetAndNumber === void 0 ? "" : _deliveryAddressStreetAndNumber, _deliveryAddressCity = param.deliveryAddressCity, deliveryAddressCity = _deliveryAddressCity === void 0 ? "" : _deliveryAddressCity, _deliveryAddressPostalCode = param.deliveryAddressPostalCode, deliveryAddressPostalCode = _deliveryAddressPostalCode === void 0 ? "" : _deliveryAddressPostalCode, _deliveryAddressCountry = param.deliveryAddressCountry, deliveryAddressCountry = _deliveryAddressCountry === void 0 ? "" : _deliveryAddressCountry, drinks = param.drinks, email = param.email, equipment = param.equipment, event_date = param.event_date, first_name = param.first_name, isPredefinedOffer = param.isPredefinedOffer, last_name = param.last_name, lead_type = param.lead_type, min_order_number = param.min_order_number, number_of_vegans = param.number_of_vegans, number_of_vegetarians = param.number_of_vegetarians, number_of_carnivore = param.number_of_carnivore, phone = param.phone, price_per_person = param.price_per_person, _predefined_catering_offer_title = param.predefined_catering_offer_title, predefined_catering_offer_title = _predefined_catering_offer_title === void 0 ? "" : _predefined_catering_offer_title, service = param.service;
    var mappedCateringCategories = catering_categories.map(function(cateringCategory) {
        return platformToSalesforceCateringCategoryMapping[cateringCategory];
    });
    var mappedEventType = catering_categories.map(function(eventType) {
        return platformToSalesforceEventTypeMapping[eventType];
    });
    var eventDate = function() {
        if (!(event_date === null || event_date === void 0 ? void 0 : event_date.date)) return undefined;
        return format(new Date(event_date.date), "dd.MM.yyyy");
    }();
    var recurringNeed = function() {
        return (event_date === null || event_date === void 0 ? void 0 : event_date.recurring) === true;
    }();
    var privateLead = function() {
        return lead_type === "private";
    }();
    var _obj;
    return _obj = {}, _define_property(_obj, salesforceFieldMapping.oid, "00D58000000ZImI"), _define_property(_obj, salesforceFieldMapping.entrance_url, Cookies.get("entrance_url")), _define_property(_obj, salesforceFieldMapping.referrer_url, Cookies.get("referrer_url")), _define_property(_obj, salesforceFieldMapping.lead_source, "heycater.com Web2Lead form"), _define_property(_obj, salesforceFieldMapping.identity, getIdentity()), _define_property(_obj, salesforceFieldMapping.city, findCityNameByLocale(city, "de") || deliveryAddressCity), _define_property(_obj, salesforceFieldMapping.conversion_url, conversion_url), _define_property(_obj, salesforceFieldMapping.first_name, first_name), _define_property(_obj, salesforceFieldMapping.last_name, last_name), _define_property(_obj, salesforceFieldMapping.company, company), _define_property(_obj, salesforceFieldMapping.email, email), _define_property(_obj, salesforceFieldMapping.phone, phone), _define_property(_obj, salesforceFieldMapping.comment, "\n-- CUSTOMER COMMENT --\n".concat(comment !== null && comment !== void 0 ? comment : "", "\n").concat(predefined_catering_offer_title && "-- PREDEFINED OFFER---\n  Pre-defined offer selected: Menu: ".concat(predefined_catering_offer_title, "\n  Caterer: ").concat(caterer_name, "\n"))), _define_property(_obj, salesforceFieldMapping.catering_categories, mappedCateringCategories), _define_property(_obj, salesforceFieldMapping.deliveryAddressStreetAndNumber, deliveryAddressStreetAndNumber), _define_property(_obj, salesforceFieldMapping.deliveryAddressCity, deliveryAddressCity), _define_property(_obj, salesforceFieldMapping.deliveryAddressPostalCode, deliveryAddressPostalCode), _define_property(_obj, salesforceFieldMapping.deliveryAddressCountry, deliveryAddressCountry), _define_property(_obj, salesforceFieldMapping.event_type, mappedEventType), _define_property(_obj, salesforceFieldMapping.event_date, eventDate), _define_property(_obj, salesforceFieldMapping.pax, min_order_number), _define_property(_obj, salesforceFieldMapping.number_of_vegans, number_of_vegans), _define_property(_obj, salesforceFieldMapping.number_of_vegetarians, number_of_vegetarians), _define_property(_obj, salesforceFieldMapping.number_of_carnivore, number_of_carnivore), _define_property(_obj, salesforceFieldMapping.total_budget, caterer_minimum_order_value), _define_property(_obj, salesforceFieldMapping.price_per_person, price_per_person), _define_property(_obj, salesforceFieldMapping.recurring_need, recurringNeed), _define_property(_obj, salesforceFieldMapping.private_lead, privateLead), _define_property(_obj, salesforceFieldMapping.record_type, SALESFORCE_LEAD_RECORD_TYPES_MAPPING["Customer Lead"]), _define_property(_obj, salesforceFieldMapping.predefined_offer, predefined_catering_offer_title ? "1" : "0"), _define_property(_obj, salesforceFieldMapping.degree_of_satiation, degree_of_satiation), _define_property(_obj, salesforceFieldMapping.predefined_offer, isPredefinedOffer), _define_property(_obj, salesforceFieldMapping.equipment, equipment), _define_property(_obj, salesforceFieldMapping.drinks, drinks), _define_property(_obj, salesforceFieldMapping.service, service), _obj;
};
var salesforceFieldMapping = {
    catering_categories: "00N1i000002IQkd",
    city: "00N5800000CZO0T",
    company: "company",
    comment: "00N58000007Q0vz",
    conversion_url: "00N1i000002WWRT",
    degree_of_satiation: "Level_of_Satiation__c",
    deliveryAddressStreetAndNumber: "00N1i000000ldlY",
    deliveryAddressCity: "00N1i000000ldli",
    deliveryAddressPostalCode: "00N1i000002H93Y",
    deliveryAddressCountry: "00N1i000002HrsJ",
    drinks: "Drinks__c",
    email: "email",
    entrance_url: "00N1i000001A0eY",
    equipment: "Furnishing__c",
    event_type: "00N1i000002WRXM",
    event_date: "00N5800000E2R9g",
    first_name: "first_name",
    identity: "00N1i000002WT1c",
    last_name: "last_name",
    lead_language: "00N1i000002Nvv0",
    lead_source: "lead_source",
    number_of_vegans: "Anzahl_Vegan__c",
    number_of_vegetarians: "Anzahl_Vegetarisch__c",
    number_of_carnivore: "Anzahl_Fleisch__c",
    oid: "oid",
    pax: "00N58000005JWfk",
    price_per_person: "00N58000009Ikbm",
    phone: "phone",
    predefined_offer: "00N9Y000000OMsR",
    private_lead: "00N1i000002Ndz8",
    referrer_url: "00N1i000001A0eT",
    total_budget: "00N58000009IkXa",
    record_type: "recordType",
    recurring_need: "00N9Y000000NseP",
    service: "Staff__c"
};
var platformToSalesforceCateringCategoryMapping = {
    breakfast: "breakfast",
    business_lunch: "business-lunch",
    drinks: "drinks",
    christmas: "christmas",
    fingerfood: "fingerfood",
    cakes_and_sweets: "snacks-and-dessert",
    street_food: "street-food",
    event: "event",
    fine_dining: "fine-dining",
    buffet: "buffet",
    specials: "specials",
    home_office: "home-office",
    bbq: "bbq",
    easter: "easter",
    halloween: "halloween",
    summer_party: "summer-party",
    other: "other"
};
var platformToSalesforceEventTypeMapping = {
    summer_party: "Sommerfeier",
    christmas: "Weihnachtsfeier"
};

;// CONCATENATED MODULE: ./src/shared/services/opportunityCreationPayload.ts


var occasionToEventMapping = {
    meeting: "Meeting",
    team_event: "Firmenfeier / Event",
    company_event: "Firmenfeier / Event",
    summer_party: "Sommerfeier",
    christmas: "Weihnachtsfeier",
    conference: "Meeting",
    shooting: "Shooting / Dreh",
    other: "Sonstiges"
};
var CLOUD_GROUPS_SLUGS = {
    CATERING_CATEGORIES: "catering-categories"
};
var prepareGroupTagValues = function(groupSlug, selectedValues) {
    return selectedValues.map(function(value) {
        return {
            tagSlug: value,
            groupSlug: groupSlug
        };
    });
};
var cloudGroupTagValuesPayload = function(payload) {
    var catering_categories = payload.catering_categories;
    var selectedCateringCategories = catering_categories.filter(function(value) {
        return value !== "other";
    }).map(function(cateringCategory) {
        return platformToSalesforceCateringCategoryMapping[cateringCategory];
    });
    return prepareGroupTagValues(CLOUD_GROUPS_SLUGS.CATERING_CATEGORIES, selectedCateringCategories);
};
function createOpportunityCreationPayload(payload) {
    var _billingAddressStreetAndNumber = payload.billingAddressStreetAndNumber, billingAddressStreetAndNumber = _billingAddressStreetAndNumber === void 0 ? "" : _billingAddressStreetAndNumber, _billingAddressPostalCode = payload.billingAddressPostalCode, billingAddressPostalCode = _billingAddressPostalCode === void 0 ? "" : _billingAddressPostalCode, _billingAddressCity = payload.billingAddressCity, billingAddressCity = _billingAddressCity === void 0 ? "" : _billingAddressCity, customer_tier = payload.customer_tier, _billingCountry = payload.billingCountry, billingCountry = _billingCountry === void 0 ? "" : _billingCountry, catering_categories = payload.catering_categories, landingPageSource = payload.landingPageSource, caterer_minimum_order_value = payload.caterer_minimum_order_value, _caterer_name = payload.caterer_name, caterer_name = _caterer_name === void 0 ? "" : _caterer_name, inspiredByMenuId = payload.inspiredByMenuId, _conversion_url = payload.conversion_url, conversion_url = _conversion_url === void 0 ? "" : _conversion_url, occasion = payload.occasion, comment = payload.comment, degree_of_satiation = payload.degree_of_satiation, _deliveryAddressStreetAndNumber = payload.deliveryAddressStreetAndNumber, deliveryAddressStreetAndNumber = _deliveryAddressStreetAndNumber === void 0 ? "" : _deliveryAddressStreetAndNumber, _deliveryAddressPostalCode = payload.deliveryAddressPostalCode, deliveryAddressPostalCode = _deliveryAddressPostalCode === void 0 ? "" : _deliveryAddressPostalCode, _deliveryAddressCity = payload.deliveryAddressCity, deliveryAddressCity = _deliveryAddressCity === void 0 ? "" : _deliveryAddressCity, _deliveryCountry = payload.deliveryCountry, deliveryCountry = _deliveryCountry === void 0 ? "" : _deliveryCountry, _drinks = payload.drinks, drinks = _drinks === void 0 ? false : _drinks, event_date = payload.event_date, _equipment = payload.equipment, equipment = _equipment === void 0 ? false : _equipment, first_name = payload.first_name, _isPredefinedOffer = payload.isPredefinedOffer, isPredefinedOffer = _isPredefinedOffer === void 0 ? false : _isPredefinedOffer, last_name = payload.last_name, min_order_number = payload.min_order_number, number_of_vegetarians = payload.number_of_vegetarians, number_of_vegans = payload.number_of_vegans, number_of_carnivore = payload.number_of_carnivore, price_per_person = payload.price_per_person, catererSlug = payload.catererSlug, _predefined_catering_offer_title = payload.predefined_catering_offer_title, predefined_catering_offer_title = _predefined_catering_offer_title === void 0 ? "" : _predefined_catering_offer_title, _reorder_offer_id = payload.reorder_offer_id, reorder_offer_id = _reorder_offer_id === void 0 ? "" : _reorder_offer_id, _service = payload.service, service = _service === void 0 ? false : _service, _leadSource = payload.leadSource, leadSource = _leadSource === void 0 ? "" : _leadSource, is_multi_day = payload.is_multi_day, analyticsClientId = payload.analyticsClientId;
    return {
        analyticsClientId: analyticsClientId,
        cateringCategories: catering_categories.map(function(cateringCategory) {
            return cateringCategory === "other" ? undefined : platformToSalesforceCateringCategoryMapping[cateringCategory];
        }),
        occasion: occasion ? occasionToEventMapping[occasion] : undefined,
        overallBudget: caterer_minimum_order_value,
        budgetPerPerson: price_per_person,
        customerTier: customer_tier,
        numberOfPeople: min_order_number,
        vegetarianNumber: number_of_vegetarians,
        veganNumber: number_of_vegans,
        meatNumber: number_of_carnivore,
        catererSlug: catererSlug,
        isMultiday: is_multi_day,
        inspiredByMenuId: inspiredByMenuId,
        landingPageSource: landingPageSource,
        internalComment: "\n    ".concat(predefined_catering_offer_title && "-- PREDEFINED OFFER---\n      Pre-defined offer selected: Menu: ".concat(predefined_catering_offer_title, "\n      Caterer: ").concat(caterer_name, "\n    "), "\n    ").concat(reorder_offer_id && "-- RE-ORDER ---\n      Re-Order offer selected: ".concat(reorder_offer_id, "\n      Link: https://heycater.lightning.force.com/lightning/r/Catering_Offer__c/").concat(reorder_offer_id, "/view\n    ")),
        commentByHeycaterForCaterer: comment,
        predefinedOffers: isPredefinedOffer,
        contactPersonNote: "".concat(first_name, " ").concat(last_name),
        billingAddressStreetAndNumber: billingAddressStreetAndNumber,
        billingAddressPostalCode: billingAddressPostalCode,
        billingAddressCity: billingAddressCity,
        billingCountry: billingCountry,
        leadSource: leadSource,
        deliveryAddressStreetAndNumber: deliveryAddressStreetAndNumber,
        deliveryAddressPostalCode: deliveryAddressPostalCode,
        deliveryAddressCity: deliveryAddressCity,
        deliveryCountry: deliveryCountry,
        drinks: drinks,
        furniture: equipment,
        staff: service,
        locationCity: deliveryAddressCity,
        conversionUrl: conversion_url,
        entranceUrl: js_cookie_default().get("entrance_url"),
        referrerUrl: js_cookie_default().get("referrer_url"),
        degreeOfSatiation: degree_of_satiation,
        eventsAttributes: [
            {
                startsAt: event_date
            }, 
        ],
        cloudGroupTagValuesAttributes: cloudGroupTagValuesPayload(payload)
    };
}


/***/ }),

/***/ 95046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A6": function() { return /* binding */ formatRating; },
/* harmony export */   "cz": function() { return /* binding */ getRatingCount; },
/* harmony export */   "h1": function() { return /* binding */ getRating; },
/* harmony export */   "mj": function() { return /* binding */ formatRatingCount; }
/* harmony export */ });
var getRating = function(ratings) {
    return ratings["overall"].rating;
};
var getRatingCount = function(ratings) {
    return ratings["overall"].count;
};
var formatRating = function(rating) {
    return (Math.round(rating * 10) / 10).toFixed(1);
};
var formatRatingCount = function(ratingCount) {
    if (ratingCount < 10) {
        return ratingCount;
    }
    if (ratingCount < 100) {
        return 10 * Math.floor(ratingCount / 10) + "+";
    }
    return 100 * Math.floor(ratingCount / 100) + "+";
};


/***/ }),

/***/ 37582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




function Logo(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1197 244.92",
        width: "150"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M512.39,180.42v-47c0-8.61-6.62-16-15.22-16.4-10.51-.47-17.94,7.63-17.94,17.83v45.56H454.72V36.25h24.51v69.2h.39c6.56-7.89,16.5-10.86,26.85-10.86,19.49,0,30.43,10.86,30.43,32.57v53.26Z",
                transform: "translate(-42 0.47)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M583.5,145.82c2,9.91,9.9,17.83,19.82,17.83s15.85-2,23.18-9.9l18.63,9.71c-10.1,14.06-22,19-41.81,19-27.75,0-45.58-18.82-45.58-44.58s17.83-44.6,45.58-44.6c26,0,44.59,19.83,44.59,42.61v9.92Zm20.36-31.72C592,114.1,586,122,584,130h39.64C621.69,122,615.74,114.1,603.86,114.1Z",
                transform: "translate(-42 0.47)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M696.22,217.9H670.41l19.86-47.64L658.5,96.8h26L702,140.05h.38l17.5-43.25h26Z",
                transform: "translate(-42 0.47)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M801.49,183.05c-27.75,0-45.58-18.82-45.58-44.58s17.84-44.6,45.58-44.6c15.86,0,25.76,5,34.67,14.88l-12.87,15.84c-5.94-5.94-10.9-9.91-21.8-9.91-11.69,0-19.82,9.91-19.82,23.79s8.92,23.77,19.82,23.77c9.91,0,15.86-4,21.8-11.89l15.86,15.86C827.25,178.1,817.35,183.05,801.49,183.05Z",
                transform: "translate(-42 0.47)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M918.94,180.42v-8.65h-.4c-6.56,8-16.53,10.95-28.49,10.95-19.93,0-37.87-16.93-37.87-44.83S870.12,93,890.05,93c12,0,21.93,3,28.49,11h.4V96.8h24.51v83.62Zm-21.11-63.75c-9.91,0-19.81,7.92-19.81,21.8s9.9,21.8,19.81,21.8c11.89,0,20.81-7.93,20.81-21.8S909.72,116.67,897.83,116.67Z",
                transform: "translate(-42 0.47)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1000.5,183.11c-13.93,0-23.89-7-23.89-24.88v-39.8H962.89l3-21.63h10.77V69.28l24.51-3.93V96.8h17.3v21.63h-17.3v31.44c0,9.84,9.17,11.79,17.3,3.94v22.33C1014.44,180.12,1006.68,183.11,1000.5,183.11Z",
                transform: "translate(-42 0.47)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1063.59,145.82c2,9.91,9.91,17.83,19.82,17.83s15.86-2,23.19-9.9l18.62,9.71c-10.11,14.06-22,19-41.81,19-27.75,0-45.59-18.82-45.59-44.58s17.84-44.6,45.59-44.6c25.95,0,44.58,19.83,44.58,42.61v9.92Zm20-31.72c-11.89,0-17.83,7.94-19.82,15.86h39.64C1101.41,122,1095.47,114.1,1083.58,114.1Z",
                transform: "translate(-42 0.47)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1168.36,136.15v44.27h-24.51V96.8h24.51v10.09h.4c6.7-10.09,12.79-13.12,27-13.12V117C1177.48,115,1168.36,123,1168.36,136.15Z",
                transform: "translate(-42 0.47)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1213.05,140.05V37.69h26V140.05Zm0,40.37V153h26v27.39Z",
                transform: "translate(-42 0.47)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "cls-1",
                d: "M137.12,236.78",
                transform: "translate(-42 0.47)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M217.92,38.07S224,25,244.68,24.74L244.3,7.06S216,6,202.38,29.36Z",
                transform: "translate(-42 0.47)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M175.26,173.1c1.11-36.37-28.88-48.59-28.88-48.59,24-43.6,24-89.54,24-89.54-1.93-41.8-42.15-35-42.15-35l1.86,17.48c24.79-3.32,22.77,19.26,22.77,19.26,2.76,27.39-24.07,84.22-24.07,84.22-34.8,0-55.72,35.91-55.72,35.91C55,190.13,60.87,214.2,76,213.27s29.8-20.73,29.8-20.73c14.26-16.29,32.95-51.65,32.95-51.65,19.07,7.59,19.25,32.59,19.25,32.59-1.95,39.54-27.39,57.94-27.39,57.94l11.84,13C178.4,212.16,175.26,173.1,175.26,173.1ZM79.18,194s5.51-44.62,39.41-53.14C118.59,140.89,91.41,188.64,79.18,194Z",
                transform: "translate(-42 0.47)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M42,87.14s21.63,6.74,32.59,15.25L85.32,88.32S65.7,73.7,44.6,69.81Z",
                transform: "translate(-42 0.47)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M306.47,120.9C305.56,96.83,273,97.38,273,97.38c-23.13.93-33.77,7.41-33.77,7.41-9.35-16.47,6.75-37,6.75-37L232.44,56.29C208.37,86.08,223.55,115,223.55,115c-31.1,26.08-32.94,56.09-15,83.67S263,227.3,263,227.3l.19-17.38c-27.21-1.84-48.12-23-48.3-45S235,128.65,235,128.65c16.29,12.77,40,14.26,40,14.26C310,143.11,306.47,120.9,306.47,120.9Zm-18.84,2.42c-2.79,3-28.69,1.3-35-4.63,0,0,20-8.32,35,0,0,0,2.77,1.67,0,4.63Z",
                transform: "translate(-42 0.47)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M316.17,190.18s4.17-9.57,20.41-21.52l-10.2-14.58s-18.95,13.47-26.3,27.63Z",
                transform: "translate(-42 0.47)"
            })
        ]
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (Logo);


/***/ }),

/***/ 36902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TrustedShopsLogo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





function TrustedShopsLogo(_param) {
    var _fill = _param.fill, fill = _fill === void 0 ? "#fff" : _fill, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "fill"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 32 32",
        fill: fill
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            id: "etrusted-logo",
            d: "M5.785,15.972A10.082,10.082,0,1,0,15.868,5.891,10.082,10.082,0,0,0,5.785,15.972ZM0,16.023a16,16,0,1,1,16,16A16,16,0,0,1,0,16.023Zm18.025-5.972a1.175,1.175,0,0,1,1.18,1.308c0,2.519-2.965,4.271-5.1,4.909.446-1.753,1.626-6.216,3.921-6.216Zm-3.538,13.2c2.74,0,4.781-1.977,6.248-4.144l-.8-.606c-1.052,1.275-2.485,3-4.271,3A2.127,2.127,0,0,1,13.626,19.1a11.714,11.714,0,0,1,.191-1.817l.445-.112c2.889-.719,7.97-1.984,7.97-5.4C22.232,9.766,20,9.1,18.343,9.1,13.4,9.1,9.9,13.75,9.9,18.5c0,2.932,1.689,4.749,4.59,4.749Z",
            transform: "translate(0 -0.024)"
        })
    }));
}


/***/ }),

/***/ 95359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TrustedShopsStars; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function TrustedShopsStars() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 111.181 18.982",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            id: "ic-review_rating",
            transform: "translate(10824 20794)",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    id: "star-filled",
                    d: "M9.489,0,7.249,7.248,0,7.251l5.865,4.48L3.627,18.982,9.488,14.5l5.868,4.48-2.239-7.251,5.865-4.48-7.249,0Z",
                    transform: "translate(-10731.801 -20794)",
                    fill: "#ffdc0f",
                    fillRule: "evenodd"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    id: "star-filled-2",
                    "data-name": "star-filled",
                    d: "M9.489,0,7.249,7.248,0,7.251l5.865,4.48L3.627,18.982,9.488,14.5l5.868,4.48-2.239-7.251,5.865-4.48-7.249,0Z",
                    transform: "translate(-10777.9 -20794)",
                    fill: "#ffdc0f",
                    fillRule: "evenodd"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    id: "star-filled-3",
                    "data-name": "star-filled",
                    d: "M9.489,0,7.249,7.248,0,7.251l5.865,4.48L3.627,18.982,9.488,14.5l5.868,4.48-2.239-7.251,5.865-4.48-7.249,0Z",
                    transform: "translate(-10754.851 -20794)",
                    fill: "#ffdc0f",
                    fillRule: "evenodd"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    id: "star-filled-4",
                    "data-name": "star-filled",
                    d: "M9.489,0,7.249,7.248,0,7.251l5.865,4.48L3.627,18.982,9.488,14.5l5.868,4.48-2.239-7.251,5.865-4.48-7.249,0Z",
                    transform: "translate(-10800.95 -20794)",
                    fill: "#ffdc0f",
                    fillRule: "evenodd"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    id: "star-filled-5",
                    "data-name": "star-filled",
                    d: "M9.489,0,7.249,7.248,0,7.251l5.865,4.48L3.627,18.982,9.488,14.5l5.868,4.48-2.239-7.251,5.865-4.48-7.249,0Z",
                    transform: "translate(-10824 -20794)",
                    fill: "#ffdc0f",
                    fillRule: "evenodd"
                })
            ]
        })
    });
}


/***/ }),

/***/ 7489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




function Berlin(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        x: "0",
        y: "0",
        viewBox: "0 0 300 300"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#4c6c21",
                d: "M52.22 276.75H28.06a1.554 1.554 0 01-1.55-1.59l3.07-105.21h-2.34c-.85 0-1.55-.69-1.55-1.55v-8.99c0-.85.69-1.55 1.55-1.55H52.8c.85 0 1.55.69 1.55 1.55v8.96c0 .85-.68 1.54-1.53 1.55l-2.12.02 3.08 105.22c.01.42-.15.82-.44 1.12-.3.3-.7.47-1.12.47zm-22.57-3.09h20.98l-3.08-105.21a1.537 1.537 0 011.53-1.59l2.17-.02v-5.88H28.79v5.9h2.39a1.554 1.554 0 011.55 1.59l-3.08 105.21zM93.34 276.75H69.18a1.554 1.554 0 01-1.55-1.59l3.07-105.21h-2.34c-.85 0-1.55-.69-1.55-1.55v-8.99c0-.85.69-1.55 1.55-1.55h25.56c.85 0 1.55.69 1.55 1.55v8.96c0 .85-.68 1.54-1.53 1.55l-2.12.02 3.08 105.22c.01.42-.15.82-.44 1.12-.3.3-.7.47-1.12.47zm-22.57-3.09h20.98l-3.08-105.21a1.537 1.537 0 011.53-1.59l2.17-.02v-5.88H69.91v5.9h2.39a1.554 1.554 0 011.55 1.59l-3.08 105.21zM134.46 276.75H110.3a1.554 1.554 0 01-1.55-1.59l3.07-105.21h-2.34c-.85 0-1.55-.69-1.55-1.55v-8.99c0-.85.69-1.55 1.55-1.55h25.56c.85 0 1.55.69 1.55 1.55v8.96c0 .85-.68 1.54-1.53 1.55l-2.12.02 3.08 105.22c.01.42-.15.82-.44 1.12-.3.3-.7.47-1.12.47zm-22.57-3.09h20.98l-3.08-105.21a1.537 1.537 0 011.53-1.59l2.17-.02v-5.88h-22.47v5.9h2.39a1.554 1.554 0 011.55 1.59l-3.07 105.21zM193.58 276.18h-24.16a1.554 1.554 0 01-1.55-1.59l3.07-105.21h-2.34c-.85 0-1.55-.69-1.55-1.55v-8.99c0-.85.69-1.55 1.55-1.55h25.56c.85 0 1.55.69 1.55 1.55v8.96c0 .85-.69 1.54-1.53 1.55l-2.12.02 3.08 105.22c.01.42-.15.82-.44 1.12-.3.3-.7.47-1.12.47zm-22.57-3.09h20.98l-3.08-105.21a1.537 1.537 0 011.53-1.59l2.17-.02v-5.88h-22.47v5.9h2.39a1.554 1.554 0 011.55 1.59l-3.07 105.21zM234.7 276.18h-24.16a1.554 1.554 0 01-1.55-1.59l3.06-105.21h-2.34c-.85 0-1.55-.69-1.55-1.55v-8.99c0-.85.69-1.55 1.55-1.55h25.56c.85 0 1.55.69 1.55 1.55v8.96c0 .85-.69 1.54-1.53 1.55l-2.12.02 3.08 105.22a1.554 1.554 0 01-1.55 1.59zm-22.57-3.09h20.98l-3.08-105.21a1.537 1.537 0 011.53-1.59l2.17-.02v-5.88h-22.47v5.9h2.39a1.554 1.554 0 011.55 1.59l-3.07 105.21zM275.82 276.18h-24.16a1.554 1.554 0 01-1.55-1.59l3.06-105.21h-2.34c-.85 0-1.55-.69-1.55-1.55v-8.99c0-.85.69-1.55 1.55-1.55h25.56c.85 0 1.55.69 1.55 1.55v8.96c0 .85-.69 1.54-1.53 1.55l-2.12.02 3.08 105.22a1.554 1.554 0 01-1.55 1.59zm-22.57-3.09h20.98l-3.08-105.21a1.537 1.537 0 011.53-1.59l2.17-.02v-5.88h-22.47v5.9h2.39a1.554 1.554 0 011.55 1.59l-3.07 105.21z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#4c6c21",
                    d: "M281.56 159.43H22.08c-.85 0-1.55-.69-1.55-1.55v-16.07c0-.85.69-1.55 1.55-1.55h259.47c.85 0 1.55.69 1.55 1.55v16.07c0 .86-.69 1.55-1.54 1.55zm-257.93-3.09h256.38v-12.98H23.63v12.98z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#4c6c21",
                    d: "M282.27 143.29s-.01 0 0 0l-259.48-.47c-.36 0-.71-.13-.99-.36l-11.34-9.45c-.5-.42-.69-1.1-.46-1.71.22-.61.8-1.02 1.45-1.02h280.74a1.543 1.543 0 011.09 2.64l-9.93 9.93c-.28.28-.67.44-1.08.44zm-258.92-3.56l258.27.47 6.83-6.83H15.72l7.63 6.36z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#4c6c21",
                    d: "M264.12 133.01H39.52c-.85 0-1.55-.69-1.55-1.55v-11.55l-8.65-7.21c-.5-.42-.69-1.1-.46-1.71.22-.61.8-1.02 1.45-1.02h243a1.543 1.543 0 011.09 2.64l-8.59 8.59c-.05.05-.1.1-.16.14v10.12c.01.85-.68 1.55-1.53 1.55zm-223.05-3.1h221.5v-9.81c0-.85.68-1.53 1.52-1.55l5.5-5.5h-235l5.92 4.94c.35.29.56.73.56 1.19v10.73z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#4c6c21",
                    d: "M111.51 87.47h80.61v24.54h-80.61z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#4c6c21",
                        d: "M117.98 86.32c-1.05-.51-2.95-1.69-3.79-3.79-1.02-2.55-.11-5.39 2.39-7.4l1.94 2.41c-1.42 1.14-1.96 2.57-1.45 3.84.47 1.18 1.75 1.91 2.28 2.16l-1.37 2.78zM127.57 86.67c-.35-.13-3.42-1.39-3.98-4.04-.23-1.08-.1-2.76 1.8-4.65l2.18 2.19c-.41.41-1.09 1.2-.96 1.82.16.8 1.49 1.57 2.07 1.8l-1.11 2.88z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#4c6c21",
                        d: "M128.84 80.31c-.12 0-.23-.01-.35-.04l-12.81-2.95a1.54 1.54 0 01-1.19-1.66l.73-7.46-3.96-3.73c-.58-.54-.65-1.43-.17-2.06l5.07-6.66c.29-.38.74-.6 1.21-.61.48.02.93.21 1.23.58l6.82 8.58c.21.26.32.58.33.91l.13 3.85 7.07 2.4a1.544 1.544 0 01.82 2.28l-3.62 5.83c-.28.47-.78.74-1.31.74zm-11.14-5.7l10.41 2.4 2.01-3.24-6.24-2.12c-.61-.21-1.03-.77-1.05-1.41l-.15-4.4-5.26-6.63-3.02 3.97 3.5 3.3c.35.33.53.8.48 1.28l-.68 6.85zM185.66 86.32l-1.35-2.78c.53-.26 1.8-.98 2.28-2.16.51-1.26-.04-2.7-1.45-3.83l1.94-2.41c2.5 2.01 3.41 4.84 2.39 7.4-.86 2.09-2.76 3.27-3.81 3.78zM176.07 86.67l-1.12-2.88c.58-.23 1.91-1 2.07-1.8.13-.63-.54-1.41-.96-1.82l2.18-2.19c1.9 1.89 2.03 3.58 1.8 4.65-.55 2.66-3.63 3.91-3.97 4.04z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#4c6c21",
                        d: "M174.8 80.31c-.53 0-1.03-.27-1.31-.73l-3.62-5.83c-.25-.4-.3-.89-.14-1.34s.51-.79.96-.94l7.07-2.4.13-3.85c.01-.33.13-.65.33-.91l6.82-8.58c.3-.37.75-.57 1.23-.58.48.01.93.23 1.21.61l5.07 6.66c.48.63.41 1.52-.17 2.06l-3.96 3.73.73 7.46c.08.77-.43 1.48-1.19 1.66l-12.81 2.95c-.12.02-.24.03-.35.03zm-1.28-6.54l2.01 3.24 10.41-2.4-.67-6.86c-.05-.48.13-.95.48-1.28l3.5-3.3-3.02-3.97-5.26 6.63-.15 4.4c-.02.64-.44 1.21-1.05 1.41l-6.25 2.13z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            fill: "#4c6c21",
                            d: "M136.87 87.64c-.81 0-1.48-.62-1.54-1.44l-.26-3.6c-.02-.27.03-.53.14-.77l2.01-4.23-3.8-3.93c-.49-.5-.57-1.27-.22-1.87l2.77-4.64.13-11.38c.01-.58.33-1.1.85-1.36.51-.26 1.13-.21 1.6.12l3.4 2.43 1.05-6.91c.11-.76.77-1.31 1.53-1.31h.04l2.83.08 3.67-4.95c.3-.4.76-.62 1.24-.63.57-.11 1.17.12 1.53.6l3.67 4.95 2.83-.08c.79-.05 1.45.54 1.57 1.31l1.05 6.91 3.4-2.43a1.54 1.54 0 011.6-.12c.51.26.84.79.85 1.36l.13 11.38 2.77 4.64c.36.6.27 1.37-.22 1.87l-3.8 3.93 2.01 4.23c.11.24.16.51.14.77l-.26 3.6a1.55 1.55 0 01-1.62 1.43l-1.95-.1c-.8-.04-1.43-.68-1.47-1.48l-.07-1.8-11.33.08c-.11.02-.21.05-.33.04l-12.39-.09-.07 1.8c-.03.8-.67 1.44-1.47 1.48l-1.95.1c0 .01-.03.01-.06.01zm2.1-6.49l13.57.1c.09-.02.19-.03.29-.03l13.13-.09-1.51-3.19c-.28-.58-.16-1.27.29-1.74l3.72-3.85-2.38-3.98c-.14-.23-.22-.5-.22-.78l-.1-8.83-3.04 2.17c-.44.31-1.01.38-1.5.17-.5-.21-.85-.66-.93-1.19l-1.22-8.05-2.27.06c-.5.03-.98-.22-1.28-.62l-1.43-1.92-.09 5.87c-.01.85-.7 1.53-1.55 1.53s-1.53-.68-1.55-1.53l-.08-5.85-1.43 1.92c-.3.4-.78.66-1.28.62l-2.27-.06-1.22 8.05c-.08.53-.43.98-.93 1.19-.49.21-1.06.15-1.5-.17l-3.04-2.17-.1 8.83c0 .27-.08.54-.22.78l-2.38 3.98 3.72 3.85c.45.46.56 1.15.29 1.74l-1.49 3.19z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            fill: "#4c6c21",
                            d: "M152.78 46.02c-3.58 0-6.49-2.4-6.49-5.36 0-2.95 2.91-5.36 6.49-5.36s6.49 2.4 6.49 5.36c0 2.96-2.91 5.36-6.49 5.36zm0-7.62c-1.84 0-3.4 1.04-3.4 2.26 0 1.23 1.56 2.26 3.4 2.26s3.4-1.04 3.4-2.26c0-1.22-1.56-2.26-3.4-2.26z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            fill: "#4c6c21",
                            d: "M152.61 37.48h-.08c-.52-.03-.99-.32-1.25-.77l-5.29-9.07 2.67-1.56 4.1 7.04 7.3-9.87 2.49 1.84-8.7 11.76c-.29.4-.75.63-1.24.63z"
                        })
                    })
                ]
            })
        ]
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (Berlin);


/***/ }),

/***/ 30947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




function Cologne(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        x: "0",
        y: "0",
        viewBox: "0 0 300 300"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#fff",
                stroke: "#5e7d2b",
                strokeWidth: "5",
                strokeLinejoin: "round",
                strokeMiterlimit: "10",
                d: "M77.41 11.74L61.54 88.57 51.52 76.88l-12.53 97.7-1.67 39.25 79.34-4.17-1.68-35.91-12.52-96.87-10.02 15.03z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#fff",
                d: "M63.92 186.89v-46.04c.26-5.82 2-11.41 5.05-16.1 1.86-2.86 5.31-8.19 8.57-8.19 4.01 0 9.6 8.39 12.52 24.42v45.91H63.92z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#5e7d2b",
                d: "M77.53 118c2.76 0 8.18 7.35 11.07 23.11v44.33H65.37v-44.53c.26-5.6 1.92-10.92 4.81-15.38 1.46-2.25 4.89-7.53 7.35-7.53m0-2.89c-4.04 0-7.62 5.52-9.78 8.85-4.32 6.66-5.12 13.33-5.28 16.89v47.49H91.5v-47.49c-2.78-15.35-8.43-25.74-13.97-25.74z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#fff",
                d: "M51.12 204.58v-31.85c.18-3.99 1.38-7.83 3.47-11.05 1.17-1.8 3.6-5.54 5.64-5.54 2.57 0 6.36 5.86 8.35 16.73v31.72H51.12z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#5e7d2b",
                d: "M60.23 157.58c1.2 0 4.87 4.44 6.9 15.41v30.14H52.57V172.8c.18-3.77 1.29-7.34 3.24-10.33 2.75-4.25 3.95-4.89 4.42-4.89m0-2.89c-2.83 0-5.34 3.87-6.86 6.2-3.03 4.67-3.59 9.35-3.7 11.84v33.29h20.35v-33.29c-1.94-10.75-5.91-18.04-9.79-18.04z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#fff",
                d: "M68.26 204.58v-31.85c.18-3.99 1.38-7.83 3.47-11.05 1.17-1.8 3.6-5.54 5.64-5.54 2.57 0 6.36 5.86 8.35 16.73v31.72H68.26z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#5e7d2b",
                d: "M77.37 157.58c1.2 0 4.87 4.44 6.9 15.41v30.14H69.71V172.8c.18-3.77 1.29-7.34 3.24-10.33 2.75-4.25 3.95-4.89 4.42-4.89m0-2.89c-2.83 0-5.34 3.87-6.86 6.2-3.03 4.67-3.59 9.35-3.7 11.84v33.29h20.35v-33.29c-1.94-10.75-5.91-18.04-9.79-18.04z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#fff",
                d: "M85.4 204.58v-31.85c.18-3.99 1.38-7.83 3.47-11.05 1.17-1.8 3.6-5.54 5.64-5.54 2.57 0 6.36 5.86 8.35 16.73v31.72H85.4z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#5e7d2b",
                d: "M94.51 157.58c1.2 0 4.87 4.44 6.9 15.41v30.14H86.85V172.8c.18-3.77 1.29-7.34 3.24-10.33 2.75-4.25 3.95-4.89 4.42-4.89m0-2.89c-2.83 0-5.34 3.87-6.86 6.2-3.03 4.67-3.59 9.35-3.7 11.84v33.29h20.35v-33.29c-1.94-10.75-5.91-18.04-9.79-18.04z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#fff",
                stroke: "#5e7d2b",
                strokeWidth: "5",
                strokeLinejoin: "round",
                strokeMiterlimit: "10",
                d: "M222.49 14.39l-15.86 76.83-10.03-11.69-12.52 97.7-1.67 39.25 79.33-4.17-1.67-35.91-12.53-96.87-10.02 15.03z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        d: "M209.01 189.54V143.5c.26-5.82 2-11.41 5.05-16.1 1.86-2.86 5.31-8.19 8.57-8.19 4.01 0 9.6 8.39 12.52 24.42v45.91h-26.14z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#5e7d2b",
                        d: "M222.62 120.65c2.76 0 8.18 7.35 11.07 23.11v44.33h-23.24v-44.53c.26-5.6 1.92-10.92 4.81-15.38 1.47-2.25 4.89-7.53 7.36-7.53m0-2.89c-4.04 0-7.62 5.52-9.78 8.85-4.32 6.66-5.12 13.33-5.28 16.89v47.49h29.03V143.5c-2.78-15.35-8.43-25.74-13.97-25.74z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "#fff",
                                d: "M196.21 207.23v-31.85c.18-3.99 1.38-7.83 3.47-11.05 1.17-1.8 3.6-5.54 5.64-5.54 2.57 0 6.36 5.86 8.35 16.73v31.72h-17.46z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "#5e7d2b",
                                d: "M205.32 160.23c1.2 0 4.87 4.44 6.9 15.41v30.14h-14.56v-30.33c.18-3.77 1.29-7.34 3.24-10.33 2.75-4.25 3.95-4.89 4.42-4.89m0-2.89c-2.83 0-5.34 3.87-6.86 6.2-3.03 4.67-3.59 9.35-3.7 11.84v33.29h20.35v-33.29c-1.95-10.75-5.91-18.04-9.79-18.04z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "#fff",
                                d: "M213.35 207.23v-31.85c.18-3.99 1.38-7.83 3.47-11.05 1.17-1.8 3.6-5.54 5.64-5.54 2.57 0 6.36 5.86 8.35 16.73v31.72h-17.46z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "#5e7d2b",
                                d: "M222.46 160.23c1.2 0 4.87 4.44 6.9 15.41v30.14H214.8v-30.33c.18-3.77 1.29-7.34 3.24-10.33 2.75-4.25 3.95-4.89 4.42-4.89m0-2.89c-2.83 0-5.34 3.87-6.86 6.2-3.03 4.67-3.59 9.35-3.7 11.84v33.29h20.35v-33.29c-1.95-10.75-5.91-18.04-9.79-18.04z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        fill: "#fff",
                                        d: "M230.49 207.23v-31.85c.18-3.99 1.38-7.83 3.47-11.05 1.17-1.8 3.6-5.54 5.64-5.54 2.57 0 6.36 5.86 8.35 16.73v31.72h-17.46z"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        fill: "#5e7d2b",
                                        d: "M239.6 160.23c1.2 0 4.87 4.44 6.9 15.41v30.14h-14.56v-30.33c.18-3.77 1.29-7.34 3.24-10.33 2.75-4.25 3.95-4.89 4.42-4.89m0-2.89c-2.83 0-5.34 3.87-6.86 6.2-3.03 4.67-3.59 9.35-3.7 11.84v33.29h20.35v-33.29c-1.95-10.75-5.91-18.04-9.79-18.04z"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        d: "M31.66 284.21V141.67c2.49-21.65 6.18-28.98 7.48-28.99 1.31 0 5.17 7.31 8.12 29v142.53h-15.6z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#5e7d2b",
                        d: "M39.17 114.71c1.67 2.56 4.47 11.06 6.65 27.07v140.98H33.11V141.75c1.84-15.95 4.45-24.45 6.06-27.04m-.03-3.48h-.02c-3.52.04-6.91 12.92-8.91 30.35v144.07h18.5V141.59c-2.37-17.51-6.04-30.36-9.57-30.36z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        d: "M49.7 284.21V207.5l-.01-.07c-.25-2.52.55-4.93 2.24-6.8 1.54-1.7 3.61-2.68 5.66-2.68.1 0 .21 0 .31.01 1.96.1 3.9 1.1 5.32 2.77 1.6 1.86 2.33 4.24 2.07 6.7l-.01.08v76.71H49.7z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#5e7d2b",
                        d: "M57.6 199.4c.08 0 .16 0 .24.01 1.56.08 3.13.9 4.29 2.26a7.36 7.36 0 011.73 5.61l-.02.15v75.34H51.15v-75.33l-.01-.14a7.28 7.28 0 011.88-5.69c1.26-1.41 2.93-2.21 4.58-2.21m0-2.89c-5.11 0-9.95 4.95-9.35 11.07v78.08h18.5v-78.08c.62-5.89-3.81-10.82-8.76-11.06-.13-.01-.26-.01-.39-.01z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        d: "M68.56 284.21v-94.88c-.09-9.81 4.8-15.91 7.5-15.97 2.8 0 7.97 6.07 8.11 15.99v94.86H68.56z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#5e7d2b",
                        d: "M76.1 174.81c1.65 0 6.49 5.01 6.62 14.52v93.44H70.01v-93.46c-.08-9.43 4.48-14.47 6.09-14.5m0-2.89h-.07c-3.87.08-9 7.12-8.91 17.41v96.33h18.5v-96.33c-.15-10.48-5.62-17.41-9.52-17.41z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "#fff",
                                d: "M86.6 284.21V207.5l-.01-.07c-.25-2.52.55-4.93 2.24-6.8 1.54-1.7 3.61-2.68 5.66-2.68.1 0 .21 0 .31.01 1.96.1 3.9 1.1 5.32 2.77 1.6 1.86 2.33 4.24 2.07 6.7l-.01.08v76.71H86.6z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "#5e7d2b",
                                d: "M94.5 199.4c.08 0 .16 0 .24.01 1.56.08 3.13.9 4.29 2.26a7.36 7.36 0 011.73 5.61l-.02.15v75.34H88.05v-75.33l-.01-.14a7.28 7.28 0 011.88-5.69c1.26-1.41 2.93-2.21 4.58-2.21m0-2.89c-5.11 0-9.95 4.95-9.35 11.07v78.08h18.5v-78.08c.62-5.89-3.81-10.82-8.76-11.06-.13-.01-.26-.01-.39-.01z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "#fff",
                                d: "M105.46 284.21v-94.88c-.09-9.81 4.8-15.91 7.5-15.97 2.8 0 7.97 6.07 8.11 15.99v94.86h-15.61z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "#5e7d2b",
                                d: "M113 174.81c1.65 0 6.49 5.01 6.62 14.52v93.44h-12.71v-93.46c-.08-9.43 4.49-14.47 6.09-14.5m0-2.89h-.07c-3.87.08-9 7.12-8.91 17.41v96.33h18.5v-96.33c-.15-10.48-5.62-17.41-9.52-17.41z"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        d: "M251.87 284.21V141.69c2.95-21.7 6.81-29 8.12-29 1.3.01 4.99 7.34 7.48 28.99v142.54h-15.6z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#5e7d2b",
                        d: "M259.96 114.71c1.6 2.59 4.21 11.1 6.06 27.04v141.01h-12.71V141.78c2.19-16.01 4.99-24.51 6.65-27.07m.03-3.48c-3.52 0-7.19 12.85-9.57 30.35v144.07h18.5V141.58c-2-17.43-5.39-30.32-8.91-30.35h-.02z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        d: "M233.83 284.21V207.5l-.01-.08c-.26-2.46.48-4.84 2.07-6.7 1.42-1.66 3.36-2.67 5.32-2.77.11-.01.21-.01.31-.01 2.06 0 4.12.98 5.66 2.68a8.757 8.757 0 012.24 6.81l-.01.07v76.71h-15.58z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#5e7d2b",
                        d: "M241.53 199.4c1.65 0 3.32.8 4.59 2.2 1.42 1.56 2.08 3.58 1.88 5.69l-.01.14v75.33h-12.71v-75.34l-.02-.15a7.36 7.36 0 011.73-5.61c1.17-1.36 2.73-2.19 4.29-2.26h.25m0-2.89c-.13 0-.26 0-.39.01-4.95.24-9.38 5.17-8.76 11.06v78.08h18.5v-78.08c.6-6.12-4.24-11.07-9.35-11.07z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        d: "M214.97 284.21v-94.88c.14-9.9 5.3-15.97 8.07-15.97 2.73.06 7.62 6.16 7.54 15.96v94.9h-15.61z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#5e7d2b",
                        d: "M223.03 171.92l.01 2.89c1.6.03 6.16 5.07 6.08 14.52v93.44h-12.71v-93.4c.13-9.55 4.97-14.56 6.62-14.56v-2.89m0 0c-3.9 0-9.37 6.93-9.51 17.42v96.33h18.5v-96.33c.09-10.3-5.05-17.33-8.91-17.41-.03-.01-.05-.01-.08-.01z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "#fff",
                                d: "M196.92 284.21V207.5l-.01-.08c-.26-2.46.48-4.84 2.07-6.7 1.42-1.66 3.36-2.67 5.32-2.77.11-.01.21-.01.31-.01 2.06 0 4.12.98 5.66 2.68a8.747 8.747 0 012.24 6.8l-.01.07v76.71h-15.58z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "#5e7d2b",
                                d: "M204.63 199.4c1.65 0 3.32.8 4.59 2.2 1.42 1.56 2.08 3.58 1.88 5.69l-.01.14v75.33h-12.71v-75.34l-.02-.15a7.36 7.36 0 011.73-5.61c1.17-1.36 2.73-2.18 4.29-2.26h.25m0-2.89c-.13 0-.26 0-.39.01-4.95.24-9.38 5.17-8.76 11.06v78.08h18.5v-78.08c.6-6.12-4.25-11.07-9.35-11.07z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "#fff",
                                d: "M178.06 284.21v-94.88c.14-9.9 5.3-15.97 8.07-15.97 2.73.06 7.62 6.16 7.53 15.96v94.9h-15.6z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "#5e7d2b",
                                d: "M186.13 171.92l.01 2.89c1.6.03 6.16 5.07 6.08 14.52v93.44h-12.71v-93.4c.13-9.55 4.97-14.56 6.62-14.56v-2.89m0 0c-3.9 0-9.37 6.93-9.51 17.42v96.33h18.5v-96.33c.09-10.3-5.05-17.33-8.91-17.41-.03-.01-.06-.01-.08-.01z"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        d: "M124.66 282.77v-93.44c.58-31.21 15.41-51.95 24.97-51.95 9.55.02 24.31 20.76 24.82 52v93.39h-49.79z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#5e7d2b",
                        d: "M149.63 140.27c2.92.01 8.21 3.82 12.92 12.19 5.57 9.87 8.76 22.98 9 36.92v90.49h-44v-90.49c.27-13.96 3.5-27.08 9.09-36.94 4.75-8.36 10.06-12.17 12.99-12.17m-.01-5.79c-11.5 0-27.25 22-27.86 54.85v96.33h55.58v-96.33c-.54-32.8-16.21-54.83-27.7-54.85h-.02z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        d: "M124.66 283.1v-80.72c.27-12.36 3.6-24.07 9.38-32.91 4.76-7.28 10.73-11.8 15.59-11.8 9.55.01 24.31 17.88 24.82 44.77v80.67h-49.79z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#5e7d2b",
                        d: "M149.63 160.56c7.44.01 21.41 15.92 21.92 41.88v77.77h-44v-77.76c.58-25.99 14.62-41.89 22.08-41.89m-.01-5.79c-11.5 0-27.25 19.09-27.86 47.61v83.61h55.58v-83.61c-.54-28.47-16.21-47.59-27.7-47.61h-.02z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        d: "M124.66 283.1v-69.71c.58-23.44 15.18-38.44 24.97-38.44 9.78.01 24.31 15.02 24.82 38.51v69.65h-49.79z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#5e7d2b",
                        d: "M149.63 177.84c3.02 0 8.32 2.39 13.33 9.08 5.31 7.09 8.36 16.51 8.59 26.53v66.75h-44v-66.74c.26-10.03 3.34-19.45 8.68-26.55 5.05-6.69 10.37-9.07 13.4-9.07m-.01-5.79c-11.5 0-27.25 16.58-27.86 41.34v72.6h55.58v-72.6c-.54-24.72-16.21-41.32-27.7-41.34h-.02z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#fff",
                stroke: "#5e7d2b",
                strokeWidth: "3",
                strokeMiterlimit: "10",
                d: "M139.21 220.62h22.54v61.61h-22.54z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#5e7d2b",
                d: "M30.38 279.48h238.54v8.38H30.38z"
            })
        ]
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (Cologne);


/***/ }),

/***/ 84786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




function Dusseldorf(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        x: "0",
        y: "0",
        viewBox: "0 0 300 300"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M286.02 286.57H13.98l.16-1.2L46.58 47.95H62.6l15.43 14.08V35.88l20.95-10.86 33.29 21.46h53.94V13.43h29.68l.13.9c3.5 23.8 23.16 25.48 24 25.54l.82.06.15.81 45.03 245.83zM16.4 284.46h267.08L239.05 41.89c-1.77-.25-6.1-1.11-10.76-3.91-5.35-3.23-12.09-9.72-14.22-22.43h-25.74V48.6h-56.68L98.87 27.46l-18.72 9.7v29.67L61.79 50.06H48.43L16.4 284.46z",
                fill: "#4c6c21",
                stroke: "#4c6c21",
                strokeWidth: "4",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                transform: "rotate(-8.922 96.417 174.978)",
                fill: "#4c6c21",
                stroke: "#4c6c21",
                strokeWidth: "2",
                strokeMiterlimit: "10",
                d: "M95.38 63.08h2.12v223.79h-2.12z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#4c6c21",
                stroke: "#4c6c21",
                strokeWidth: "2",
                strokeMiterlimit: "10",
                d: "M163.15 47.43h2.12v238.08h-2.12zM187.23 47.43h2.12v238.08h-2.12z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                transform: "rotate(-86.474 72.285 174.973)",
                fill: "#4c6c21",
                stroke: "#4c6c21",
                strokeWidth: "2",
                strokeMiterlimit: "10",
                d: "M-38.46 173.92h221.5v2.12h-221.5z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#4c6c21",
                d: "M41.3 258.01H31.14a2.57 2.57 0 01-2.57-2.57V226.5a2.57 2.57 0 012.57-2.57H41.3a2.57 2.57 0 012.57 2.57v28.94c.01 1.41-1.15 2.57-2.57 2.57zm-10.16-31.97c-.25 0-.46.21-.46.46v28.94c0 .25.2.46.46.46H41.3c.25 0 .46-.21.46-.46V226.5c0-.25-.2-.46-.46-.46H31.14zM63.08 202.55H42.7a2.57 2.57 0 01-2.57-2.57v-6.63a2.57 2.57 0 012.57-2.57h20.38a2.57 2.57 0 012.57 2.57v6.63c0 1.42-1.16 2.57-2.57 2.57zm-20.38-9.66c-.25 0-.46.2-.46.46v6.63c0 .25.2.46.46.46h20.38c.25 0 .46-.21.46-.46v-6.63c0-.25-.2-.46-.46-.46H42.7zM65.39 162.84H45.01a2.57 2.57 0 01-2.57-2.57v-13.58a2.57 2.57 0 012.57-2.57h20.38a2.57 2.57 0 012.57 2.57v13.58c.01 1.41-1.15 2.57-2.57 2.57zm-20.38-16.61c-.25 0-.46.21-.46.46v13.58c0 .25.2.46.46.46h20.38c.25 0 .46-.2.46-.46v-13.58c0-.25-.2-.46-.46-.46H45.01zM58.65 130.91H47.12a2.57 2.57 0 01-2.57-2.57v-7.3a2.57 2.57 0 012.57-2.57h11.53a2.57 2.57 0 012.57 2.57v7.3c.01 1.42-1.15 2.57-2.57 2.57zm-11.53-10.33c-.25 0-.46.21-.46.46v7.3c0 .25.2.46.46.46h11.53c.25 0 .46-.21.46-.46v-7.3c0-.25-.2-.46-.46-.46H47.12zM69.07 108.52H49.64a2.57 2.57 0 01-2.57-2.57v-12.9a2.57 2.57 0 012.57-2.57h19.43a2.57 2.57 0 012.57 2.57v12.9c.01 1.42-1.15 2.57-2.57 2.57zM49.64 92.59c-.25 0-.46.21-.46.46v12.9c0 .25.2.46.46.46h19.43c.25 0 .46-.21.46-.46v-12.9c0-.25-.2-.46-.46-.46H49.64zM65.38 186.59H42.19c-1.14 0-2.07-1.15-2.07-2.57v-6.63c0-1.42.93-2.57 2.07-2.57h23.18c1.14 0 2.07 1.15 2.07 2.57v6.63c0 1.41-.92 2.57-2.06 2.57zm-23.19-9.66c-.2 0-.37.2-.37.46v6.63c0 .25.16.46.37.46h23.18c.2 0 .37-.21.37-.46v-6.63c0-.25-.16-.46-.37-.46H42.19zM245.7 211.22h-35.97a2.57 2.57 0 01-2.57-2.57v-6.63a2.57 2.57 0 012.57-2.57h35.97a2.57 2.57 0 012.57 2.57v6.63c0 1.42-1.16 2.57-2.57 2.57zm-35.98-9.66c-.25 0-.46.21-.46.46v6.63c0 .25.2.46.46.46h35.97c.25 0 .46-.21.46-.46v-6.63c0-.25-.2-.46-.46-.46h-35.97zM249.56 171.51h-35.97a2.57 2.57 0 01-2.57-2.57v-13.58a2.57 2.57 0 012.57-2.57h35.97a2.57 2.57 0 012.57 2.57v13.58c0 1.41-1.16 2.57-2.57 2.57zm-35.98-16.61c-.25 0-.46.21-.46.46v13.58c0 .25.2.46.46.46h35.97c.25 0 .46-.21.46-.46v-13.58c0-.25-.2-.46-.46-.46h-35.97zM236.35 132.68h-35.97a2.57 2.57 0 01-2.57-2.57v-5.27a2.57 2.57 0 012.57-2.57h35.97a2.57 2.57 0 012.57 2.57v5.27c0 1.41-1.15 2.57-2.57 2.57zm-35.97-8.31c-.25 0-.46.21-.46.46v5.27c0 .25.2.46.46.46h35.97c.25 0 .46-.21.46-.46v-5.27c0-.25-.2-.46-.46-.46h-35.97zM236.35 111.24h-35.97a2.57 2.57 0 01-2.57-2.57v-5.27a2.57 2.57 0 012.57-2.57h35.97a2.57 2.57 0 012.57 2.57v5.27c0 1.41-1.15 2.57-2.57 2.57zm-35.97-8.3c-.25 0-.46.21-.46.46v5.27c0 .25.2.46.46.46h35.97c.25 0 .46-.21.46-.46v-5.27c0-.25-.2-.46-.46-.46h-35.97zM227 89.8h-26.62a2.57 2.57 0 01-2.57-2.57v-5.27a2.57 2.57 0 012.57-2.57H227a2.57 2.57 0 012.57 2.57v5.27A2.57 2.57 0 01227 89.8zm-26.62-8.3c-.25 0-.46.21-.46.46v5.27c0 .25.2.46.46.46H227c.25 0 .46-.21.46-.46v-5.27c0-.25-.2-.46-.46-.46h-26.62zM248.68 195.26h-50.1a2.57 2.57 0 01-2.57-2.57v-6.63a2.57 2.57 0 012.57-2.57h50.1a2.57 2.57 0 012.57 2.57v6.63c.01 1.42-1.15 2.57-2.57 2.57zm-50.1-9.66c-.25 0-.46.21-.46.46v6.63c0 .25.2.46.46.46h50.1c.25 0 .46-.21.46-.46v-6.63c0-.25-.2-.46-.46-.46h-50.1zM154.5 85.41H94.84a2.57 2.57 0 01-2.57-2.57V72.38a2.57 2.57 0 012.57-2.57h59.66a2.57 2.57 0 012.57 2.57v10.45c0 1.42-1.15 2.58-2.57 2.58zM94.84 71.93c-.25 0-.46.21-.46.46v10.45c0 .25.2.46.46.46h59.66c.25 0 .46-.21.46-.46V72.38c0-.25-.2-.46-.46-.46H94.84zM154.5 110.9h-51.57a2.57 2.57 0 01-2.57-2.57v-4.94a2.57 2.57 0 012.57-2.57h51.57a2.57 2.57 0 012.57 2.57v4.94a2.57 2.57 0 01-2.57 2.57zm-51.57-7.96c-.25 0-.46.21-.46.46v4.94c0 .25.2.46.46.46h51.57c.25 0 .46-.21.46-.46v-4.94c0-.25-.2-.46-.46-.46h-51.57zM154.5 139.15h-39.22a2.57 2.57 0 01-2.57-2.57v-4.94a2.57 2.57 0 012.57-2.57h39.22a2.57 2.57 0 012.57 2.57v4.94a2.57 2.57 0 01-2.57 2.57zm-39.22-7.96c-.25 0-.46.21-.46.46v4.94c0 .25.2.46.46.46h39.22c.25 0 .46-.21.46-.46v-4.94c0-.25-.2-.46-.46-.46h-39.22zM154.5 170.86h-39.22a2.57 2.57 0 01-2.57-2.57v-11.85a2.57 2.57 0 012.57-2.57h39.22a2.57 2.57 0 012.57 2.57v11.85a2.57 2.57 0 01-2.57 2.57zm-39.22-14.88c-.25 0-.46.2-.46.46v11.85c0 .25.2.46.46.46h39.22c.25 0 .46-.21.46-.46v-11.85c0-.25-.2-.46-.46-.46h-39.22zM154.5 197.79h-30.29a2.57 2.57 0 01-2.57-2.57v-9.19a2.57 2.57 0 012.57-2.57h30.29a2.57 2.57 0 012.57 2.57v9.19c0 1.41-1.15 2.57-2.57 2.57zm-30.29-12.22c-.25 0-.46.21-.46.46v9.19c0 .25.2.46.46.46h30.29c.25 0 .46-.21.46-.46v-9.19c0-.25-.2-.46-.46-.46h-30.29zM154.5 226.04h-30.29a2.57 2.57 0 01-2.57-2.57v-9.19a2.57 2.57 0 012.57-2.57h30.29a2.57 2.57 0 012.57 2.57v9.19a2.57 2.57 0 01-2.57 2.57zm-30.29-12.22c-.25 0-.46.21-.46.46v9.19c0 .25.2.46.46.46h30.29c.25 0 .46-.21.46-.46v-9.19c0-.25-.2-.46-.46-.46h-30.29zM59.24 286.57H49.08a2.57 2.57 0 01-2.57-2.57v-51.6a2.57 2.57 0 012.57-2.57h10.16a2.57 2.57 0 012.57 2.57V284a2.57 2.57 0 01-2.57 2.57zm-10.16-54.62c-.25 0-.46.21-.46.46V284c0 .25.2.46.46.46h10.16c.25 0 .46-.21.46-.46v-51.6c0-.25-.2-.46-.46-.46H49.08zM257.77 258.01h-22.99a2.57 2.57 0 01-2.57-2.57V226.5a2.57 2.57 0 012.57-2.57h22.99a2.57 2.57 0 012.57 2.57v28.94c0 1.41-1.16 2.57-2.57 2.57zm-23-31.97c-.25 0-.46.21-.46.46v28.94c0 .25.2.46.46.46h22.99c.25 0 .46-.21.46-.46V226.5c0-.25-.2-.46-.46-.46h-22.99zM216.85 286.57h-10.16a2.57 2.57 0 01-2.57-2.57v-51.6a2.57 2.57 0 012.57-2.57h10.16a2.57 2.57 0 012.57 2.57V284c0 1.42-1.16 2.57-2.57 2.57zm-10.17-54.62c-.25 0-.46.21-.46.46V284c0 .25.2.46.46.46h10.16c.25 0 .46-.21.46-.46v-51.6c0-.25-.2-.46-.46-.46h-10.16z"
            })
        ]
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (Dusseldorf);


/***/ }),

/***/ 16707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




function Franfurt(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        x: "0",
        y: "0",
        viewBox: "0 0 300 300"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "none",
                stroke: "#4c6c21",
                strokeWidth: "5",
                strokeMiterlimit: "10",
                d: "M6.04 269.04h285.61M6.04 277.85h285.61"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M67.8 268.03c13.2-9.62 46.49-31.14 94.13-33.72 59.08-3.21 101.01 24.84 113.27 33.72",
                fill: "none",
                stroke: "#4c6c21",
                strokeWidth: "5",
                strokeLinecap: "round",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "none",
                stroke: "#4c6c21",
                strokeMiterlimit: "10",
                strokeWidth: "5",
                d: "M165.17 278.92v-44.09M179.17 278.92v-44.09"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "none",
                stroke: "#4c6c21",
                strokeWidth: "3",
                strokeMiterlimit: "10",
                d: "M110.92 234.04V79.05h14.51v24.36h7.78v11.4h5.7v12.44h6.22v-10.37h12.96v33.17h5.7v17.11h10.37v11.4h7.78v42.51M191.26 219v-74.12h9.33v-12.96h7.78v12.44h11.4v8.29h9.85v79.83M239.47 232.48v-22.81h4.15v-30.06h6.22v-30.07h6.73v30.59h7.78v27.99h5.7v38.36M73.38 245.18V74.28h9.52V42.69h10.66V24.8h12.94v209.25M62.41 261.71v-95.8h-5.59v-18.43H44.31v-87.9h-9.88v84.14H17.64v12.82h-6.91v105.17"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#4c6c21",
                d: "M15.18 162.04h7.57v7.57h-7.57zM15.18 171.46h7.57v7.57h-7.57zM25.07 171.46h7.57v17.01h-7.57zM25.07 162.04h7.57v7.57h-7.57zM35.43 162.04H43v7.57h-7.57zM35.43 171.46H43v7.57h-7.57zM80.74 79.05h3.79v121.83h-3.79zM196.04 159.43h27.83v5.11h-27.83zM196.04 167.69h27.83v5.11h-27.83zM196.04 175.96h27.83v5.11h-27.83z"
            })
        ]
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (Franfurt);


/***/ }),

/***/ 91689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




function Hamburg(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        x: "0",
        y: "0",
        viewBox: "0 0 300 300"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17.48 58.21s22.09 20.99 49.15-23.2c0 0 47.5 67.93 76.21 31.48 0 0 38.11 82.29 80.08 33.69 0 0 31.48 39.76 57.99 24.85v155.19H15.82l1.66-222.01z",
                fill: "none",
                stroke: "#4c6c21",
                strokeWidth: "5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M66.79 37.77v243m-50.81-73.45l49.38-2.21 216.73 9.94m-266.11-.16l49.38-2.2 216.73 9.94M96.61 278.56v-64.61m56.05 66.51v-64.62m52.26 62.22v-58.81m51.51 60.88v-58.81",
                fill: "none",
                stroke: "#4c6c21",
                strokeWidth: "3",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M28.26 78.64h8.15c.09 4.42-2.19 7.45-3.91 7.49-1.75.05-4.22-2.94-4.24-7.49zm14.56 9.93h8.15c.09 4.42-2.19 7.45-3.91 7.49-1.75.05-4.22-2.94-4.24-7.49zm-4.63 23.5h8.15c.09 4.42-2.19 7.45-3.91 7.49-1.75.04-4.23-2.95-4.24-7.49zm0 24.16h8.15c.09 4.42-2.19 7.45-3.91 7.49-1.75.04-4.23-2.95-4.24-7.49zm9.92 10.92h8.15c.09 4.42-2.19 7.45-3.91 7.49-1.74.04-4.22-2.95-4.24-7.49zm-20.51 22.5h8.15c.09 4.42-2.19 7.45-3.91 7.49-1.75.05-4.23-2.95-4.24-7.49zm0-22.17h8.15c.09 4.42-2.19 7.45-3.91 7.49-1.75.04-4.23-2.95-4.24-7.49zm2.98-21.51h8.15c.09 4.42-2.19 7.45-3.91 7.49-1.75.04-4.23-2.95-4.24-7.49zm16.87 56.59h8.15c.09 4.42-2.19 7.45-3.91 7.49-1.74.04-4.22-2.95-4.24-7.49zm33.1-74.79h8.15c.09 4.42-2.19 7.45-3.91 7.49-1.75.04-4.23-2.95-4.24-7.49zm26.82-6.68h8.15c.09 4.42-2.19 7.45-3.91 7.49-1.75.05-4.22-2.95-4.24-7.49zM82.84 79.94h8.15c.09 4.42-2.19 7.45-3.91 7.49-1.75.05-4.23-2.94-4.24-7.49zm4.23 47.8h8.15c.09 4.42-2.19 7.45-3.91 7.49-1.75.05-4.23-2.95-4.24-7.49zm36.8 3.81h8.15c.09 4.42-2.19 7.45-3.91 7.49-1.75.04-4.23-2.95-4.24-7.49zm-7.2 24.11h8.15c.09 4.42-2.19 7.45-3.91 7.49-1.74.04-4.22-2.95-4.24-7.49zm35.11 12.69h8.15c.09 4.42-2.19 7.45-3.91 7.49-1.74.04-4.22-2.95-4.24-7.49zm26.23-18.62h8.15c.09 4.42-2.19 7.45-3.91 7.49-1.75.05-4.23-2.94-4.24-7.49zM211 133.66h8.15c.09 4.42-2.19 7.45-3.91 7.49-1.75.05-4.22-2.95-4.24-7.49zm38.49 33.42h8.15c.09 4.42-2.19 7.45-3.91 7.49-1.74.04-4.22-2.95-4.24-7.49zm0 26.64h8.15c.09 4.42-2.19 7.45-3.91 7.49-1.74.05-4.22-2.94-4.24-7.49z",
                fill: "#4c6c21"
            })
        ]
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (Hamburg);


/***/ }),

/***/ 38595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




function Munich(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        x: "0",
        y: "0",
        viewBox: "0 0 300 300"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#4c6c21",
                d: "M107.3 244.15c-.76-12.34-5.91-22.79-11.26-22.79-5.44 0-10.49 10.29-11.27 22.93v40.47h22.53v-40.61zm-19.73 37.82v-37.59c.8-13.1 6.02-20.22 8.48-20.22s7.67 7.09 8.47 20.08v37.74H87.57v-.01zM139.8 244.15c-.76-12.34-5.91-22.79-11.26-22.79-5.44 0-10.49 10.29-11.27 22.93v40.47h22.53v-40.61zm-19.74 37.82v-37.59c.8-13.1 6.02-20.22 8.48-20.22 2.46 0 7.67 7.09 8.47 20.08v37.74h-16.95v-.01zM172.29 244.15c-.76-12.34-5.91-22.79-11.26-22.79-5.44 0-10.49 10.29-11.27 22.93v40.47h22.53v-40.61zm-19.73 37.82v-37.59c.8-13.1 6.02-20.22 8.48-20.22s7.67 7.09 8.47 20.08v37.74h-16.95v-.01zM204.78 244.15c-.76-12.34-5.91-22.79-11.26-22.79-5.44 0-10.49 10.29-11.27 22.93v40.47h22.53v-40.61zm-19.73 37.82v-37.59c.8-13.1 6.02-20.22 8.48-20.22s7.67 7.09 8.47 20.08v37.74h-16.95v-.01zM237.28 244.15c-.76-12.34-5.91-22.79-11.26-22.79-5.44 0-10.49 10.29-11.27 22.93v40.47h22.53v-40.61zm-19.74 37.82v-37.59c.8-13.1 6.02-20.22 8.48-20.22s7.67 7.09 8.47 20.08v37.74h-16.95v-.01zM269.77 244.15c-.76-12.34-5.91-22.79-11.26-22.79-5.44 0-10.49 10.29-11.27 22.93v40.47h22.53v-40.61zm-19.73 37.82v-37.59c.8-13.1 6.02-20.22 8.48-20.22s7.67 7.09 8.47 20.08v37.74h-16.95v-.01z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#4c6c21",
                d: "M284.46 288.92H15.54V145.28h231.51l23.91 37.92-.16 10.81 4.53.08 9.12 13.53v81.3h.01zm-262.59-6.33h256.27v-73.04l-6.2-9.2-7.55-.13.22-15.24-21.04-33.38H21.87v130.99z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#4c6c21",
                d: "M16.45 149.87c-.3-1.68-.59-3.36-.89-5.04 1.84-3.81 3.68-7.62 5.52-11.44V67.7c-3.59-3.57-5.56-7.96-5.56-12.45 0-11.39 12.38-20.66 27.59-20.66S70.7 43.86 70.7 55.25c0 4.3-1.74 8.39-5.03 11.89v66.4l6.89 14.81c-18.7.51-37.4 1.02-56.11 1.52zM43.11 38.39c-13.12 0-23.8 7.57-23.8 16.86 0 3.72 1.71 7.26 4.95 10.24l.61.56v68.22l-5.17 10.39 46.91-.11-4.74-10.19v-68.8l.56-.56c2.93-2.89 4.47-6.27 4.47-9.77.01-9.27-10.66-16.84-23.79-16.84zM43.11 33.25c-1.4 0-2.53-1.13-2.53-2.53V16.61c0-1.4 1.13-2.53 2.53-2.53s2.53 1.13 2.53 2.53v14.11c0 1.4-1.13 2.53-2.53 2.53z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                fill: "#4c6c21",
                cx: "43.11",
                cy: "32.11",
                r: "5.01"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#4c6c21",
                d: "M22.65 65h40.93v3.79H22.65zM22.65 75.67h40.93v3.79H22.65zM22.65 105.46h40.93v3.79H22.65zM22.65 132.68h40.93v3.79H22.65zM43.11 129.96c-4.91 0-8.9-3.99-8.9-8.9s3.99-8.9 8.9-8.9 8.9 3.99 8.9 8.9-3.99 8.9-8.9 8.9zm0-15.27c-3.51 0-6.37 2.86-6.37 6.37s2.86 6.37 6.37 6.37 6.37-2.86 6.37-6.37-2.85-6.37-6.37-6.37z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#4c6c21",
                d: "M53.47 107.39H32.75c-.7 0-1.26-.57-1.26-1.26V91.28c0-.51.31-.97.78-1.17L42.8 85.7c.32-.13.68-.13.99 0l10.19 4.41c.46.2.76.66.76 1.16v14.84c0 .71-.57 1.28-1.27 1.28zm-19.46-2.53h18.2V92.11l-8.94-3.87-9.26 3.88v12.74z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "none",
                stroke: "#4c6c21",
                strokeMiterlimit: "10",
                d: "M83.1 134.57h40.93"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#4c6c21",
                stroke: "#4c6c21",
                strokeMiterlimit: "10",
                d: "M83.1 132.68h40.93v3.79H83.1z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#4c6c21",
                d: "M72.76 148.49l7.51-15.09V67.71c-3.59-3.57-5.56-7.96-5.56-12.45 0-11.39 12.38-20.66 27.59-20.66s27.59 9.27 27.59 20.66c0 4.3-1.74 8.39-5.03 11.89v66.4l6.89 14.81-58.99.13zm29.54-110.1c-13.12 0-23.8 7.57-23.8 16.86 0 3.72 1.71 7.26 4.95 10.24l.61.56v68.22l-5.17 10.39 46.91-.11-4.74-10.19v-68.8l.56-.56c2.93-2.89 4.47-6.27 4.47-9.77.01-9.27-10.66-16.84-23.79-16.84zM102.3 33.25c-1.4 0-2.53-1.13-2.53-2.53V16.61c0-1.4 1.13-2.53 2.53-2.53s2.53 1.13 2.53 2.53v14.11c0 1.4-1.13 2.53-2.53 2.53z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                fill: "#4c6c21",
                cx: "102.3",
                cy: "32.11",
                r: "5.01"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#4c6c21",
                d: "M81.84 65h40.93v3.79H81.84zM81.84 75.67h40.93v3.79H81.84zM81.84 105.46h40.93v3.79H81.84z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    className: "prefix__st0",
                    d: "M112.67 107.39H91.94c-.7 0-1.26-.57-1.26-1.26V91.28c0-.51.31-.97.78-1.17l10.53-4.41c.32-.13.68-.13.99.01l10.19 4.41c.46.2.76.66.76 1.16v14.84c0 .7-.57 1.27-1.26 1.27zm-19.47-2.53h18.2V92.11l-8.94-3.87-9.26 3.88v12.74z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#4c6c21",
                    stroke: "#4c6c21",
                    strokeMiterlimit: "10",
                    d: "M71.17 151.77h5.06V285.7h-5.06z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#4c6c21",
                    stroke: "#4c6c21",
                    strokeMiterlimit: "10",
                    d: "M33.07 151.3h2.53v133.93h-2.53z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#4c6c21",
                    stroke: "#4c6c21",
                    strokeMiterlimit: "10",
                    d: "M57.26 151.77h2.53V285.7h-2.53z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#4c6c21",
                    stroke: "#4c6c21",
                    strokeMiterlimit: "10",
                    d: "M74.59 182.83h193.19v2.53H74.59z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#4c6c21",
                    stroke: "#4c6c21",
                    strokeMiterlimit: "10",
                    d: "M73.53 196.57h195.96v3.79H73.53z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                stroke: "#4c6c21",
                strokeMiterlimit: "10",
                fill: "none",
                strokeWidth: "2",
                d: "M15.85 171.74h57.08M15.85 190.43h57.08M15.85 209.12h57.08M15.85 227.81h57.08M15.85 246.5h57.08M15.85 265.19h57.08"
            })
        ]
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (Munich);


/***/ }),

/***/ 98839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




function Other(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "41",
        viewBox: "0 0 32 41",
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M15.8016 39.9251L15.8014 39.9249C15.527 39.6833 11.9212 36.4691 8.39218 31.8285C4.83574 27.1518 1.5 21.2099 1.5 15.486C1.5 7.4993 8.00568 1 16 1C23.9943 1 30.5 7.4993 30.5 15.486C30.5 21.2099 27.1643 27.1518 23.6078 31.8287C20.0899 36.4549 16.4956 39.664 16.2 39.9253C16.142 39.9755 16.0718 40 16 40C15.9281 40 15.8588 39.9754 15.8016 39.9251ZM6.38889 15.375C6.38889 20.6448 10.7072 24.9167 16 24.9167C21.2928 24.9167 25.6111 20.6448 25.6111 15.375C25.6111 10.1052 21.2928 5.83333 16 5.83333C10.7072 5.83333 6.38889 10.1052 6.38889 15.375Z",
            stroke: "#C4C4C4",
            strokeWidth: "2"
        })
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (Other);


/***/ }),

/***/ 61737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




function Stuttgart(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        x: "0",
        y: "0",
        viewBox: "0 0 300 300"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#5e7d2b",
                d: "M153.67 89.31h-7.59V2.44h7.59v86.87zm-5.25-2.34h2.91V4.78h-2.91v82.19z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#5e7d2b",
                d: "M147.25 13.52h5.15v1.17h-5.15zM147.51 25.74h5.15v1.17h-5.15zM147.6 37.96h5.15v1.17h-5.15zM123.56 85.3h52.88v3.22h-52.88z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#5e7d2b",
                stroke: "#5e7d2b",
                strokeMiterlimit: "10",
                d: "M183.02 109.44h-66.04V87.39h66.04v22.05zm-63.7-2.33h61.36V89.73h-61.36v17.38z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#5e7d2b",
                d: "M163.05 116.55l-27.05-.16-16.45-7.46h61l-17.5 7.62zm-26.68-1.27h.08l26.35.1 12.13-5.28h-49.98l11.42 5.18z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#5e7d2b",
                d: "M166.71 123.33H133.3v-7.94h33.41v7.94zm-32.25-1.17h31.08v-5.6h-31.08v5.6z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#5e7d2b",
                    d: "M160.36 131.97h-20.72v-9.11h20.72v9.11zm-18.38-2.34h16.04v-4.43h-16.04v4.43z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#5e7d2b",
                    stroke: "#5e7d2b",
                    strokeMiterlimit: "10",
                    d: "M169.09 297.56h-37.02l9.47-167.86 17.64-1.04 9.91 168.9zm-33.32-3.5h29.6l-9.49-161.69-11.03.65-9.08 161.04z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#5e7d2b",
                    d: "M140.65 127.21h18.7v7.31h-18.7z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#5e7d2b",
                    d: "M149.42 149.83h1.17v21.56h-1.17z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#5e7d2b",
                    d: "M149.42 181.41h1.17v21.56h-1.17z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#5e7d2b",
                    d: "M149.42 212.99h1.17v21.56h-1.17z"
                })
            })
        ]
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (Stuttgart);


/***/ }),

/***/ 10904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ buildFunnelUrl; },
/* harmony export */   "H": function() { return /* binding */ buildAddress; },
/* harmony export */   "bB": function() { return /* binding */ buildFaqMarkup; },
/* harmony export */   "fm": function() { return /* binding */ capitalizeFirstLetter; }
/* harmony export */ });
/* unused harmony export parsedQueryParams */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _contentful_rich_text_plain_text_renderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32924);
/* harmony import */ var lodash_toPairs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93220);
/* harmony import */ var lodash_toPairs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_toPairs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var qualification_schema_questions_cateringCategoriesQuestion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61535);
/* harmony import */ var qualification_schema_questions_cityQuestion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26407);







var buildFaqMarkup = function(faqs) {
    return {
        "@context": "https://schema.org/",
        "@type": "FAQPage",
        mainEntity: faqs.map(function(faq) {
            return {
                "@type": "Question",
                name: faq.fields.question,
                acceptedAnswer: {
                    "@type": "Answer",
                    text: (0,_contentful_rich_text_plain_text_renderer__WEBPACK_IMPORTED_MODULE_0__/* .documentToPlainTextString */ .a)(faq.fields.answer)
                }
            };
        })
    };
};
var buildFunnelUrl = function(param) {
    var city = param.city, cateringCategories = param.cateringCategories, selectedCatererId = param.selectedCatererId, router = param.router;
    var parsedParameters = {};
    if (city) {
        parsedParameters.city = (0,qualification_schema_questions_cityQuestion__WEBPACK_IMPORTED_MODULE_3__/* .isValidCity */ .m0)(city.toLowerCase()) ? city.toLowerCase() : "other";
    }
    if (selectedCatererId) {
        parsedParameters.selectedCatererId = selectedCatererId;
    }
    if (Array.isArray(cateringCategories)) {
        var validCateringCategories = cateringCategories.filter(qualification_schema_questions_cateringCategoriesQuestion__WEBPACK_IMPORTED_MODULE_2__/* .isValidCateringCategory */ .kl);
        if (validCateringCategories.length) {
            parsedParameters.catering_categories = validCateringCategories;
        } else {
            parsedParameters.catering_categories = [
                "other"
            ];
        }
    }
    return "/start".concat((0,qs__WEBPACK_IMPORTED_MODULE_4__.stringify)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, parsedParameters), {
        leadSource: "".concat("https://www.heycater.com").concat(router.asPath.split("?")[0])
    }), {
        addQueryPrefix: true
    }));
};
var parsedQueryParams = function() {
    if (false) {}
    return parse(window.location.search, {
        ignoreQueryPrefix: true
    });
};
var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
    if (!string) {
        return "";
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
};
var buildAddress = function(addressComponents) {
    return lodash_toPairs__WEBPACK_IMPORTED_MODULE_1___default()(addressComponents).map(function(component) {
        if (!component[1]) return "";
        switch(component[0]){
            case "street":
                return "".concat(component[1], ", ");
            case "postalCode":
                return "".concat(component[1], " ");
            case "city":
                return component[1];
            case "country":
                return ", ".concat(component[1]);
            default:
                return component[1];
        }
    }).join("");
};


/***/ }),

/***/ 10758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95197);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  --padding: ",
        "px;\n\n  --contentMaxWidth: ",
        "px;\n\n  --maxWidthIncludingPadding: calc(\n    var(--contentMaxWidth) + (2 * var(--padding))\n  );\n\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: var(--padding);\n  padding-right: var(--padding);\n\n  width: clamp(100px, 100%, var(--maxWidthIncludingPadding));\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var sizes = {
    xs: 690,
    xsm: 860,
    sm: 930,
    md: 1250,
    lg: 1890
};
var StyledContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(_heycater_design_system__WEBPACK_IMPORTED_MODULE_1__.Box)(_templateObject(), function(param) {
    var theme = param.theme, disableGutters = param.disableGutters, padding = param.padding;
    return disableGutters ? 0 : theme.spacing(padding !== null && padding !== void 0 ? padding : 2);
}, function(param) {
    var size = param.size;
    return typeof size === "number" ? size : sizes[size || "md"];
});
var Container = StyledContainer;
/* harmony default export */ __webpack_exports__["Z"] = (Container);


/***/ })

}]);